export default {
    "accountValidateMsg" : "A conta deve conter 6 a 30 caracteres, incluindo letras, dígitos e símbolos (\".\", \"_\", \"@\"). O primeiro caractere deve ser dígito ou letra.",
    "storeSuccess" : "Recarga feita com sucesso",
    "editAccountTips" : "Por favor insira um nome de conta válido",
    "editPwdTips" : "Por favor insira uma senha válida",
    "editRepeatPwdTips" : "Por favor insira sua senha novamente",
    "pwdRepeatTips" : "As senhas não coincidem",
    "changePwdSucc" : "Sua senha foi mudada",
    "bindEmail" : "Vincular E-mail",
    "verifyEmail" : "Verificação de segurança da conta",
    "errorVrifyCodeTips" : "Erro de código de verificação",
    "slectQuessionTips" : "Por favor, selecione uma pergunta de segurança?",
    "answerTips" : "Por favor insira a resposta",
    "twoAnswerTips" : "Selecione as questões de segurança criadas e insira as respostas corretas",
    "realNameValidateTips" : "Nome real (4 a 60 caracteres)",
    "phoneValidateTips" : "Número de Telefone (6 a 18 dígitos)",
    "areaSelectTips" : "Por favor, selecione a região",
    "iDCardValidataTips" : "Número de ID (1 a 60 dígitos)",
    "changeProfileSucc" : "Informações atualizadas guardada",
    "editVrfCodeTips" : "Por favor insira o código de verificação",
    "securityQuestionTips" : "Por favor, crie questões de segurança para melhorar a segurança da sua conta. Quando você esquecer sua senha, poderá responder às perguntas para redefinir a senha.",
    "validateQuessionTips" : "Por favor, selecione duas questões diferentes e verifique. Você pode recriar as perguntas após a verificação.",
    "originPwd" : "Senha original",
    "newPwd" : "Nova senha",
    "changePwdSuccess" : "Senha alterada. Sugerimos que você faça login novamente agora para salvar seu progresso.",
    "accountName" : "Nome da conta",
    "password" : "Digite a senha",
    "repeatPassword" : "Por favor, repita sua senha",
    "findPwdTips" : "Por favor, insira a conta da qual você deseja recuperar a senha",
    "submit" : "enviar",
    "send" : "Mandar",
    "modify" : "modificar",
    "haveAgree" : "Aceita",
    "and" : "e",
    "privacyPolicy" : "Política de Privacidade",
    "completeness" : "Conclusão",
    "gender" : "Gênero",
    "male" : "masculino",
    "female" : "fêmea",
    "birthday" : "Aniversário",
    "phone" : "Telefone",
    "region" : "Região",
    "ID" : "ID",
    "accountSetting" : "Configurações da Conta",
    "upgrade" : "Atualizar",
    "profile" : "Perfil",
    "changePassword" : "Mudar Senha",
    "securityQuestion" : "Questões de Segurança",
    "creatework_headerTitle" : "Criar Ticket",
    "mylist_headerTitle" : "Meu Ticket",
    "bindEmailTips" : "Verifique seu e-mail para a segurança da sua conta. Se você esqueceu sua senha, nós lhe enviaremos um email para este endereço de e-mail.",
    "verifyEmailTips" : "Detectamos que sua conta está entrando em um novo dispositivo ou em um ambiente incomum. Para proteger os ativos da sua conta, conclua a verificação de identidade.",
    "enterEmailVrfcationTips" : "Por favor, insira o código de verificação aqui.",
    "cancel" : "CANCELAR",
    "bindTps" : "Vincula sua conta para jogar o jogo em vários dispositivos!",
    "login" : "Fazer login",
    "logout" : "Sair",
    "bind" : "Vincular Conta",
    "feedback" : "Comentários",
    "terms" : "Acordos",
    "tips" : "Aviso",
    "debindTips" : "Desativar pode resultar em perda de dados. Tem certeza de que deseja desvincular?",
    "debindText" : "Desvincular",
    "guestSwitchTips" : "Conta de convidado detectada. Após o login, os dados da sua conta de convidado serão perdidos. Continuar?",
    "register" : "Registrar",
    "realName" : "realName",
    "enterEmailTips" : "Por favor, insira o seu endereço de e-mail",
    "emailVAlidateMsg" : "E-mail inválido",
    "editEmaileTips" : "Por favor, indique o seu endereço de e-mail",
    "checkServiceTips" : "Por favor, leia os Termos de Uso e Política de Privacidade primeiro.",
    "brithdayValidateTips" : "Insira seu aniversário",
    "facebookValidateTips" : "Conta do Facebook (1 a 60 caracteres)",
    "eritOriginPwdTips" : "Senha original",
    "submitSuccess" : "Submitted",
    "rebindEmail" : "Alterar o e-mail vinculado",
    "bindEmailSuccess" : "Email vinculado: \$email</br>Por favor, use um e-mail vinculado para verificar. Você pode redefinir seu e-mail após a verificação.",
    "reSetSecurityQuessoon" : "Você criou com êxito as questões de segurança </br></br>Por favor, selecione diferentes questões e verifique. Você pode recriar as perguntas após a verificação.",
    "canotModifyTips" : "As alterações NÃO são permitidas no momento do envio, com certeza serão enviadas?",
    "rebindEmailTips" : "Seu e-mail é: \$email, por favor, toque aqui para obter o código de verificação",
    "reGetVrfCode" : "Obter código",
    "findPwdWayTips" : "Por favor, selecione uma das seguintes formas",
    "emailWay" : "Recuperar por e-mail de segurança",
    "emailWayTips" : "Você receberá um correio de confirmação e poderá redefinir a senha",
    "quessionWay" : "Recuperar por questões de segurança",
    "quessionWayTips" : "Responda as perguntas de segurança criadas e redefina a senha",
    "resetPwdBtn" : "Redefinir a senha",
    "lastStep" : "Anterior",
    "sendEmailTips" : "Enviamos um correio para \$email.<br>Por favor, insira o código de verificação que você recebeu aqui.",
    "setNewPwdTips" : "Parabéns!<br>Identidade do usuário verificada. Agora você pode redefinir sua senha.",
    "termsOfUse" : "Termos de Uso",
    "copy_success" : "Copiado",
    "creatework_create" : "Ticket",
    "creatework_createHolder" : "Selecione o tipo",
    "creatework_title" : "Assunto",
    "creatework_titleHolder" : "Por favor insira um assunto",
    "creatework_detail" : "detalhes",
    "creatework_detailHolder" : "Descrição não deve conter mais de 200 caracteres",
    "creatework_uploadTips" : "Por favor carregue somente arquivos jpg/png. O arquivo enviado deve ter menos de 5 MB.",
    "creatework_selectBox_selectTile" : "Tipo",
    "creatework_goGame" : "Retorna",
    "creatework_history" : "História",
    "mylist_noYet" : "Sem registro",
    "mywork_solved" : "Problema resolvido?",
    "mywork_service" : "Nos avalie",
    "mywork_messageHolder" : "Nova mensagem",
    "mywork_score" : "Ponto",
    "mywork_confirm" : "CONFIRME",
    "creatework_selectBox_selectList3" : "Outros",
    "creatework_selectBox_selectList2" : "Conta",
    "close" : "Perto",
    "creatework_gameHolder" : "Selecione o jogo",
    "creatework_serverHolder" : "Selecionar Servidor",
    "contactService" : "Entre em contato com o CS",
    "FAQ" : "FAQ",
    "creatework_game" : "Jogos:",
    "creatework_server" : "Servidor:",
    "creatework_role" : "Personagem:",
    "selectRoleName" : "Selecione o personagem",
    "creatework_noRole" : "Nenhum personagem",
    "creatework_noGame" : "Lista de jogos está vazia",
    "creatework_noServer" : "Lista de servidores está vazia",
    "termText" : "Eu concordo com {mainHost}",
    "backLogin" : "DECLÍNIO",
    "creatework_roleHolder" : "Acesse depois de escolher seu personagem",
    "findPwdFailTips" : "Você não definiu questões de segurança. Por favor, entre em contato com o serviço ao cliente.",
    "payMall" : "Shopping",
    "selectPayment" : "quantidade",
    "plzSelectPayWay" : "selecionar canal",
    "gainPlus" : "Adicionar",
    "gainMorePlus" : "Adicione mais",
    "gainMostPlus" : "Max",
    "plzSelectPayType" : "Selecione o método de pagamento",
    "roleName" : "Personagem",
    "payWay" : "Canal de Pagamento",
    "plzSelectOtherWay" : "Canal de Pagamento Alternativo",
    "payment" : "Montante",
    "compensateTips" : "O excedente será devolvido para você em \$gameCode",
    "extaGain" : "Bônus",
    "gameGold" : "Moeda no jogo",
    "compensate" : "Compensação",
    "payWayPlus" : "Bônus de Canal",
    "neddPay" : "Pagamento",
    "submitOrder" : "Enviar",
    "screenshotTips" : "Nota: Faça uma captura de tela da sua transação caso houver algum erro na transação.",
    "storeFail" : "Failed to recharge",
    "storeFailTips" : "Falha na transação. Por favor, envie o pedido novamente ou entre em contato com o nosso serviço ao cliente.",
    "storeAcceptance" : "Em processamento",
    "storeSuccessTips" : "A transação será feita em 15 minutos.",
    "orderNumber" : "Número do pedido",
    "buyProduct" : "Item de recarga",
    "transactionAmount" : "Montante",
    "failReason" : "Razão",
    "payOntherORder" : "Novo pedido",
    "reStore" : "Recarregue novamente",
    "confirm" : "Confirme",
    "switch" : "Mudar de Conta",
    "completeTips" : "Por favor, preencha suas informações pessoais. <mark class=\"yellowMarkColor\">As informações não serão editáveis novamente</mark>. Quando você está tentando recuperar uma conta perdida, você será solicitado a fornecer informações pessoais corretas.",
    "creatework_selectBox_selectList0" : "Erro do Jogo",
    "creatework_selectBox_selectList1" : "Erro de Pagamento",
    "creatework_selectBox_selectList4" : "Erro de Tradução",
    "mywork_solvedText" : "Problema Resolvido",
    "browserPayErrBtnText" : "Erro de Pagamento",
    "browserPaySucBtnText" : "Pagamento completo",
    "browserPayingTips" : "Redirecionando para a plataforma de terceiros. <br/>Pode fechar esta página após o pagamento.",
    "price_list_empty" : "Nenhuma soma aplicável",
    "pointCardTips" : "Note: Este item suporta apenas o cartão \$paymentAmount",
    "forgetPwd" : "Esqueceu a senha?",
    "payCenter" : "Centro de Recarga",
    "willGet" : "Você vai ter",
    "goods" : "item",
    "discount" : "Bônus",
    "payDiscount" : "Compensação",
    "payDiscountTips" : "Quantia excedente será devolvida na moeda correspondente.",
    "hasQuestionPlease" : "Se você tiver alguma dúvida, por favor",
    "pwdValidateMsg" : "6 a 20 caracteres",
    "payWayPlusC" : "Bônus de Canal",
    "fwtk" : "TERMOS DE SERVIÇO",
    "yszc" : "POLÍTICA DE PRIVACIDADE",
    "exchange" : "Troca de código de presente",
    "remember" : "Lembrar escolha",
    "thirdInfo" : "Sobre conta",
    "thirdInfoContent" : "Por favor, ligue sua conta no Centro de Usuários do jogo. Depois disso, faça o login no jogo usando a conta vinculada.",
    "unLink" : "Atualmente, este método não é suportado",
    "favour" : "Marca páginas",
    "goStoreTip" : "Por favor, prossiga para a página de pagamento",
    "go" : "Vai",
    "otherLogin" : "Outros métodos de login",
    "qrCodeTip" : "Digitalize o código QR para começar!",
    "favourTip" : "Marque a página para jogar novamente mais tarde!",
    "share" : "Compartilhar",
    "landscapeTip" : "Por favor, prossiga no modo retrato",
    "leaveTip" : "Saia do jogo?",
    "selectRole" : "Escolha seu personagem",
    "selectMoney" : "Escolha a opção",
    "seletGameInfoFirst" : "Por favor escolha o jogo",
    "lowerIE" : "IE version too old",
    "linkTermText" : "I have accepted {mainHost} [Terms of Use] and [Privacy Policy]",
    "download" : "Download",
    "favourAndDownloadTip" : "Bookmark this page to browser or download on PC",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "countryCode" : "Country code",
    "deleteaccount_title1" : "Delete Account",
    "deleteaccount_title2" : "Request account deletion",
    "deleteaccount_step1_1" : "Your account will be frozen for 14 days since the account deletion. After 14 days, your account will be permanently deleted. You will not be able to log in with other social accounts.",
    "deleteaccount_step1_2" : "You may revoke the deletion within the 14 days through the link below:",
    "deleteaccount_step1_3" : "Once deleted, you will not be able to restore your account information. You will not be compensated for any loss caused by account deletion.",
    "deleteaccount_step1_4" : "Are you sure you want to delete your account?",
    "deleteaccount_step2_1" : "Please confirm that you want to delete your account and character.",
    "deleteaccount_step2_2" : "Please type \\&quot;Delete\\&quot; to complete the deletion.",
    "deleteaccount_step3" : "Your account will be deleted in 14 days.",
    "accountrecovery_note" : "Note:",
    "accountrecovery_tips" : "You may only revoke account deletion during the 14-day frozen period.",
    "accountrecovery_Submitted2" : "Revocation submitted. Your account will be restored later.",
    "accountrecovery_Failed" : "Failed",
    "accountrecovery_Failed_1" : "Account status is normal. You may log in.",
    "accountrecovery_Failed_2" : "Character information not found.",
    "accountrecovery_success" : "Account restored",
    "account_normal" : "Account status is normal. No need to restore.",
    "account_unablerestore" : "Account has been deleted. Unable to restore.",
    "accountrecovery_roleHolder" : "Enter  your character name",
    "accountrecovery_headerTitle" : "Revoke Account Deletion",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Account Recovery",
    "inputAccount" : "Please enter the account name that you wish to recover",
    "applyForAccountFix" : "Account Recovery",
    "nonEnterItem" : "Information to add: Registration Date; Model Number; Device Name; Passport or ID Number, Contact E-mail; Please fill in the blanks",
    "resetOT" : "Time out, please submit the Review again",
    "addOT" : "Time out, please submit the Additional Information again",
    "errorPwd" : "Password has to be 6-20 characters, including letters, numbers, \".\", \"_\", \"@\"",
    "verifyAccount" : "Account info is missing, please check again.",
    "selectRegisterTime" : "Please choose your registration time.",
    "enterBindEmail" : "Please insert your verified email.",
    "enterUsedPhoneType" : "Please insert the model of your mobile phone.",
    "enterIdfaGpid" : "Please insert the UDID of your device.",
    "enterContactEmail" : "Incorrect format of Contact E-mail Address; Please re-enter",
    "confirmTermsPrivacy" : "Please read and agree to the service terms and privacy policy.",
    "enterRechargeRemark" : "Please insert your recharge record.",
    "uploadImg" : "Please upload an Image Scan of your ID, maximum size is 20MB",
    "selectIDType" : "Please select the type of your identification document.",
    "enterIDNum" : "Please insert your passport number or ID number.",
    "enterIP" : "Please insert the IP address you used for registration.",
    "enterQueryNum" : "Please enter Review ID",
    "enterQueryPwd" : "Please enter Review Password",
    "errorQueryItem" : "Incorrect Review ID or Password, please try again",
    "enterPassword" : "Please insert a new password.",
    "enterPasswordAgain" : "Please confirm your new password.",
    "enterPasswordNonSame" : "Inconsistent Password",
    "enterEmail" : "Please enter e-mail address",
    "sendSuccess" : "E-mail has been sent",
    "enterCode" : "Please enter the Verification Code",
    "errorCode" : "Incorrect verification code",
    "selectQuest" : "Please select a Security Question",
    "enterAnswer" : "Please enter the answer",
    "selectDifferQuest" : "Please select 3 Security Questions and answers",
    "addSuccess" : "Your information has been submitted.",
    "picFormt" : "Picture format must be jpg, png or gif",
    "countdownBefore" : "Reset Countdown",
    "countdownAfter" : "(The link will expire at 00:00:00, please submit your application again )",
    "uploadDone" : "Upload done",
    "uploadFail" : "Upload failed",
    "applySuccess" : "Application Approved",
    "applyFailed" : "Application Denied",
    "resetQuestAlterFailed" : "Failed to change security question.",
    "resetQuestError" : "Data input error.",
    "resetQuestNone" : "Inquiry order not found.",
    "resetQuestAltered" : "Security questions have been changed.",
    "illegalOperation" : "Illegal Operation",
    "queryNotExist" : "Inquiry number does not exist.",
    "queryPasswordError" : "Find Password Error",
    "auditing" : "Pending approval",
    "notPass" : "Denied",
    "suppleInformation" : "Submit supplementary information",
    "suppleInformationUnHandle" : "Supplementary information submitted, pending process.",
    "suppleInformationTimeout" : "Submit supplementary information timeout.",
    "repairedAccountSuccess" : "Account repair has been completed.",
    "repairedAccountLost" : "Account repair operation has failed.",
    "loginStateNone" : "Not logged in or session has expired.",
    "repairedAccountTimeout" : "Account repair duration has expired.",
    "changePasswordSucc" : "Password changed.",
    "emailSendFailed" : "Failed to send mail.",
    "emailSendLimit" : "The mailbox may not receive any more verification codes today.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "E-mail verification code has been sent.",
    "alterSuccess" : "Change saved",
    "questionAlterSuccess" : "Security question has been changed.",
    "username" : "Account name",
    "code" : "Please enter the verification code here",
    "selectServiceType" : "Please select Service Type",
    "submitForm" : "Submit the Form",
    "apply" : "Apply",
    "reviewApplicationStatus" : "Review Application Status",
    "instantReviewOfTheStatus" : "Instant Review of the Status",
    "reviewStatus" : "Review Status",
    "backToLogin" : "Back to login",
    "previous" : "Previous",
    "applyDesc" : "Please enter the information so that we can help. You must fill in the blanks with a * . If such information was missing in your account, please enter \"None\".",
    "additionalServices" : "Additional Services",
    "resetSecurityEmail" : "Reset Security E-mail",
    "resetSecurityQuest" : "Reset Security Questions",
    "registrationDate" : "Registration Date",
    "month" : "Month",
    "year" : "Year",
    "emailBound" : "E-mail Bound",
    "modelNumber" : "Mobile model type;",
    "deviceName" : "Device Name",
    "provideRecharge" : "Please provide a detailed and complete Recharge Record, including Time, Method, Amount, Order Number, and Transaction ID for us to confirm.",
    "selectCountry" : "Region",
    "passportID" : "Passport/ ID",
    "upload" : "Upload",
    "del" : "delete",
    "pleaseUpload" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadAgain" : "Upload again",
    "enterDesc" : "Please enter any information that proves the ownership of the account",
    "contactEmail" : "Contact E-mail",
    "applyNoteAttr" : "Note",
    "applyNoteDate" : "please provide your e-mail address so that you can receive the results of your application",
    "agree" : "I have agreed to",
    "UJOYTerms" : "Terms of Use",
    "privacy" : "Privacy Policy",
    "reviewStatusOfAccountFix" : "Review Status of Account Fix",
    "enterReviewID" : "Please enter Review ID",
    "enterReviewPwd" : "Please enter Review Password",
    "review" : "Review",
    "reviewNoteAttr" : "Note",
    "reviewNoteData" : "Check your Contact E-mail in case you forgot the Review ID and Review Password",
    "haveResetInfo" : "You\'ve reset your info",
    "resetProfile" : "Reset your Profile",
    "desc" : "Parabéns! Sua verificação foi aprovada. Por favor, redefina suas informações.",
    "resetAccountDesc" : "Atenção: Você deve completar todos os itens de redefinição abaixo para desbloquear sua conta.",
    "changePwd" : "Change Password",
    "resetPwd" : "Reset Password",
    "reset" : "Reset",
    "enterNewPwd" : "Please enter new password",
    "confirmNewPwd" : "Please confirm new password",
    "successResetPwd" : "Successfully Reset password",
    "bindSecurityEmail" : "Bind Security E-mail",
    "resetPwdDesc" : "Reset password when you forgot password or account was stolen",
    "bindCommon" : "Bind",
    "sendCommon" : "Send",
    "enterVcode" : "Please enter the Verification Code",
    "successResetEmail" : "Successfully Reset Security E-mail",
    "resetQuest" : "Reset Security Questions",
    "resetQuestDesc" : "Reset password when you forget your password or you believe your account info was stolen",
    "successResetQuest" : "Successfully Reset Security Questions",
    "hide" : "Hide",
    "addRegisterTime" : "Registration time;",
    "modelNum" : "Model Number: IDFA/GPID",
    "registrationIP" : "Registration IP;",
    "addRechargeRecord" : "Recharge record;",
    "serviceReply" : "Reply from Customer Service:",
    "addDataLimitTime" : "Date for Adding Addititional Information:",
    "addMoreInfo" : "Add More Information",
    "applicationSubmit" : "Application submitted",
    "underReviewStatus" : "Your profile is under review, you will get reply in the next working day. Review status:",
    "reviewID" : "Review ID",
    "reviePwd" : "Review Password",
    "enterReviewIDNPwd" : "Enter Review ID and Review Password to check status",
    "homepage" : "Homepage",
    "checkEmailAttr" : "Note",
    "checkEmailData" : "Check your Contact E-mail in case you forgot your Review ID and Review Password",
    "underReview" : "Under Review",
    "underReviewReply" : "Your profile is under review.We will reply as soon as possible. Thank you for your patience!",
    "failed" : "Application Failed",
    "reason" : "Reason: ### Therefore, application failed, please provide correct information, our staff will help. Thank you for your cooperation!",
    "underReviewAdd" : "Your profile is under review. Part of the information is missing or inconsistent, please add more information for us to confirm!",
    "addInfoRequired" : "Additional Information Required",
    "dateForAddInfo" : "Date for Adding Addititional Information:",
    "addInfo" : "Additional Information",
    "addInfoSubmit" : "Additional Information has been submitted! Thank you for your patience!",
    "hasBeenRepaired" : "Account has been repaired",
    "opExpired" : "Account repair operation expired",
    "approved" : "Approved",
    "haveSubmitted" : "You\'ve submitted",
    "sessionExpired" : "You\'ve not yet logged in or session value has expired",
    "submitted" : "Submitted",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Inconsistent ID Number;",
    "addItemIDPhoto" : "ID Photo;",
    "idfaTitle" : "How to find your device IDFA or GPID?",
    "idfaSubTitle1" : "For ios user—finding your IDFA",
    "idfaSubTitle1Desc1" : "1.Download the app 【<em>MyIDFA</em>】from App Store",
    "idfaSubTitle1Desc2" : "2.Open this <em>app</em> and you will find your device <em>IDFA</em>.",
    "idfaSubTitle2" : "For Android user—finding your GPID",
    "idfaSubTitle2Desc1" : "1.tab the <em>“settings”</em> button",
    "idfaSubTitle2Desc2" : "2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page",
    "idfaSubTitle2Desc3" : "3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>",
    "uploadIDCard" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadTipsBefore" : "File size must not be greater than",
    "uploadTipsAfter" : "M",
    "submitError" : "Error caused by missing ID number or wrong account info.",
    "applyLimitError" : "Daily application limit exceeded. (3 times each day)",
    "applyDisabled" : "You may only submit once every 10 minutes.",
    "inputDataError" : "Data is not completed.",
    "dataException" : "Data exception",
    "picSizeLimit" : "Picture file size must not exceed 5MB",
    "picTypeLimit" : "Upload JPG, PNG, GIF files only",
    "picNull" : "Picture is empty",
    "alteredPassword" : "Password has been changed.",
    "inputError" : "Input error.",
    "pwdChangefailed" : "Failed to change password.",
    "sendEmailCodeDisabled" : "Verification code can only be sent again after a period of time.",
    "alteredEmail" : "E-mail has been changed.",
    "inputEmailError" : "E-mail input error",
    "operationFailed" : "Operation failed",
    "codeNull" : "You have not entered a verification code yet.",
    "findPwd" : "Forgot password",
    "findAccountAndPwd" : "Forgot account/password",
    "usualDeviceNum" : "Model Number: IDFA/GPID",
    "usualPhoneNum" : "Device Name",
    "registerTimeError" : "Inconsistent Registration Date;",
    "bindEMailError" : "Inconsistent Bound E-mail;",
    "rechargeRecordError" : "Inconsistent Recharge Record;",
    "registerIPError" : "Inconsistent Registration IP address;",
    "deviceNumError" : "Inconsistent IDFA/GPID;",
    "deviceModelError" : "Inconsistent Device Model;",
    "confirmTerms" : "Please agree to terms of service",
    "applyFixAccount" : "Se o procedimento acima não funcionar, você pode solicitar a <span>recuperação da conta</span>.",
    "findPwdByFixAccount" : "You are advised to set a security e-mail for account recovery.",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "Bookmark to browser! (This account has claimed the reward already)",
    "h5_favour_get_gift" : "Congrats! You obtained the reward. Please check in-game.",
    "h5_get_gift_fault" : "Unable to claim. Please try again later, and contact our CS if the problem remains.",
    "h5_favour_please_select" : "Please choose server/character",
    "h5_favour_login_get" : "Log in and bookmark to the browser to claim a reward!",
    "h5_favour_tip" : "Bookmark to the browser to claim a reward!",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "You may not purchase the selected item through this payment method.",
    "SwitchWithThirdWay" : "Mude para \${type}",
    "moreGame" : "Mais jogos",
    "serviceTitle" : "Service",
    "h5_download_login" : "Please log in first.",
    "h5_download_tips" : "Please start the game from the client.",
    "h5_download_repeat_get" : "You have claimed this giftpack.",
    "h5_download_succ" : "Please download the client first.",
    "h5_download_repeat_role" : "Character is bound",
    "currentLoginAccount" : "Current account:",
    "fb_canvas_fullscreen" : "Expand",
    "fb_canvas_website" : "Homepage",
    "fb_canvas_like_share" : "Share",
    "fb_canvas_service" : "Support",
    "fb_canvas_login_fail" : "Login failed",
    "fb_canvas_pay_return" : "You have cancelled the transaction",
    "fb_canvas_root_tip" : "Please log in Facebook to authorize first",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "within the 14 days. Revoke now?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Tem certeza de que deseja excluir a conta junto com seus dados?",
    "account_delete_fwq" : "Servidora",
    "account_delete_zhm" : "Personagem",
    "account_delete_jshflj" : "Link de recuperação de Personagem",
    "account_delete_qzyzmdxx" : "(Sensível a maiúsculas e minúsculas)",
    "account_delete_jtbcysxx" : "É recomendável fazer uma captura de tela das informações acima para recuperação de contas.",
    "deleteaccount_step3_2" : "After 14 days, your account will be deleted. You will not be able to restore your account. You will lose all your account information.\n\nYou may revoke the account deletion through",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "Inquérito Ao questionário",
    "h5_header_store_text" : "Recharge",
    "h5_header_home_text" : "Homepage",
    "h5_check_gift_list_text" : "Info de Recompensa",
    "yourServer" : "Seu Servidor",
    "allServer" : "Todos os servidores",
    "h5_header_screen" : "Tela Cheia",
    "h5_verticalTip" : "Recomendamos modo paisagem.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Recentes",
    "moreGames" : "Mais",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "padrão",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Bônus de forma de pagamento\nMoeda bônus = Quantidade page*taxa de moeda * taxa do bônus x Bônus de Método de Pagamento\nMoeda bônus = Quantidade page*taxa de moeda * taxa do bônus\n*Nota: a moeda bônus não será contabilizada para eventos de recarga ou EXP de VIP.*No caso dos jogos com lançamento global, os pagamentos serão feitos em dólares americanos. Por favor, entre em contato com o serviço de atendimento caso tenha quaisquer dúvidas.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "Caso queira salvar o número do seu cartão na página anterior, os dados do seu cartão (**** **** **** 1234) serão coletados em um formato criptografado.",
    "quickcard_result_tip_two" : "Nós apenas armazenamos os detalhes para sua conveniência, assim você não precisará colocar dados de cartões novamente na próxima vez que efetuar uma compra.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Declaração sobre credenciais armazenadas",
    "quickcard_info_tip_one" : "Para melhor proteger os dados dos usuários, as bandeiras Visa e Mastercard estão introduzindo novas termos para as “credenciais armazenadas”, assim como novas regras para armazenamento de credenciais e transações iniciadas por vendedores.",
    "quickcard_info_tip_two" : "Quando você faz uma compra em nosso website, nós coletamos os dados do seu cartão (1234 **** **** 1234) de forma criptografada. Nós armazenaremos esses dados por 4 anos e atualizaremos o acordo e política de privacidade em nosso website caso haja alguma mudança. Nós apenas armazenamos os detalhes para sua conveniência, assim você não precisará colocar dados de cartões novamente na próxima vez que efetuar uma compra.",
    "search_product" : "encontrar item",
    "search_price" : "encontrar preço",
    "price" : "preço",
    "product_no_found" : "No items are found",
    "price_no_found" : "No price are found",
    "search_no_found" : "No items/price are found",
    "product" : "item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Selecione seu personagem",
    "storeSocialLogin" : "Entrar com uma conta SNS",
    "storeAccountIdLogin" : "Entrar com uma ID",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Pesquisar",
    "storeSelectProductTitle" : "Escolha os itens",
    "storeInputNameSearch" : "Digite o nome do item para pesquisar",
    "storeInputPriceSearch" : "Digite o preço do item para pesquisar",
    "storeNoFindProduct" : "Item não encontrado. Por favor, tente novamente.",
    "storePriceUp" : "Preço↑",
    "storePriceDown" : "Preço↓",
    "storeLookDetail" : "Detalhes",
    "storeChangeProduct" : "Trocar item",
    "storeWelcome" : "Boas vindas",
    "storeLookMore" : "Mais",
    "storeHasSelect" : "Item selecionado",
    "storeTotal" : "Total",
    "storeExtra" : "Bônus",
    "storeProductDetail" : "Detalhes",
    "storeUidGuideStep1" : "Toque em Configurações > Mais > Conta",
    "storeUidGuideStep2" : "Digite a ID da conta ao fazer a recarga",
    "storeSelectAndLook" : "Selecione seu personagem primeiro",
    "storeSwitchWay" : "Trocar método de login",
    "type1" : "Promoção Diária",
    "type2" : "Herói",
    "type3" : "Equipamento de Batalha",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Recurso",
    "type8" : "Aceleração de Construção",
    "type9" : "Itens Raros",
    "type10" : "Aliança",
    "type11" : "Diamante",
    "type12" : "Módulo",
    "type13" : "Cubo",
    "type14" : "",
    "type15" : "Nanoarma",
    "type16" : "Grande Prêmio",
    "type17" : "",
    "type9999" : "Oferta limitada",
    "type10000" : "Centro de Presentes",
    "type10001" : "Eventos de Festividades",
    "typeother" : "Outros Produtos",
    "switchChar" : "Trocar personagem",
    "howToFindUid" : "Como encontro a ID da minha conta?",
    "choosePayWay" : "Escolha um método de pagamento",
    "new_apple_deleteaccount_stepsub_title" : "Cancelar renovação automática",
    "new_apple_deleteaccount_stepsub_1" : "Uma assinatura com renovação automática foi encontrada na sua conta. Recomendamos que você cancele a renovação automática antes de excluir a conta para evitar compras acidentais.",
    "new_apple_deleteaccount_stepsub_2" : "Cancelar renovação automática",
    "new_apple_deleteaccount_stepsub_later" : "Mais tarde",
    "new_apple_deleteaccount_stepsub_now" : "Agora",
    "new_apple_deleteaccount_title" : "Solicitar exclusão de conta",
    "new_apple_deleteaccount_step1_1" : "Por favor, leia atentamente os seguintes termos e condições:",
    "new_apple_deleteaccount_step1_2" : "Após a exclusão, sua conta será <span class=\"highlight\">excluída permanentemente.</span> Você NÃO poderá usá-la para entrar no jogo. Todas as informações apagadas da sua conta NÃO poderão ser recuperadas.",
    "new_apple_deleteaccount_step1_3" : "Se você deseja desvincular sua rede social, entre em contato com a equipe de atendimento para realizar o procedimento antes de excluir sua conta. Caso contrário, você não poderá usar a sua conta de rede social vinculada para entrar no jogo após a exclusão. Não se esqueça de descartar corretamente seus ativos virtuais no jogo antes de solicitar a exclusão de sua conta.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">Se você deseja solicitar um reembolso, também faça isso antes de excluir sua conta. </span>Por favor, certifique-se de ter descartado corretamente seus ativos virtuais antes de excluir sua conta.",
    "new_apple_deleteaccount_step2_1" : "Você descartou seus ativos virtuais no jogo? Caso contrário, entre em contato com o serviço de atendimento para resolver a questão antes de prosseguir.",
    "new_apple_deleteaccount_step2_2" : "Digite \"Delete\" para finalizar a exclusão. Esta ação não poderá ser desfeita.",
    "new_apple_deleteaccount_step2_3" : "Digite \"Delete\" para finalizar a exclusão",
    "new_apple_deleteaccount_step3_1" : "Sua solicitação de exclusão de conta foi realizada. A seguinte conta foi excluída:",
    "new_apple_deleteaccount_step3_2" : "Crie uma nova conta para entrar no jogo novamente.",
    "new_apple_deleteaccount_step4_1" : "Você deletou sua conta antiga. Entre com uma nova conta na próxima vez.",
    "currencyTypeName" : "Moeda",
    "has_select_product" : "Seus itens:",
    "n_product" : "\${n}",
    "look_detail_product" : "Ver tudo",
    "limit_buy_product" : "Limite de compras para este item: \${n}",
    "limit_order" : "Você só pode comprar até \${n} unidades por vez.",
    "limit_order_remove_tip" : "Você alcançou o limite de compras para alguns itens no carrinho. Deseja removê-los?",
    "paytype_limit" : "Este método de pagamento não pode ser usado para comprar alguns dos seus itens. Por favor, escolha um método diferente ou tente comprá-los separadamente.",
    "check_remove_cart" : "Remover do carrinho?",
    "remove_cart" : "Remover",
    "confirm_product" : "Confirmar",
    "select_paytype" : "Escolha um método de pagamento",
    "cart_is_empty_tip" : "Nenhum item encontrado. Selecione um item primeiro.",
    "thirty_tip" : "Se os itens que você comprou não aparecerem em até 30 minutos, entre em contato com o atendimento.",
    "total_n_product" : "Item x\${n}",
    "look_detail_of_cart" : "Ver tudo",
    "order_detail" : "Lista de itens",
    "total_detail" : "Quantidade:",
    "add_to_cart" : "Adicionar ao carrinho",
    "back_to_select" : "Voltar",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "Confirme",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Visit \nWebsite",
    "visitorLogin" : "Guest",
    "tokenLogin" : "OTP",
    "fbLogin" : "log in with Facebook",
    "googleLogin" : "Log in with Google",
    "twitterLogin" : "Log in with Twitter",
    "vkLogin" : "Log in with VK",
    "agreementTextStart" : "By logging into the game, you confirm that you have read and agree to the Terms of Service and Privacy Policy.",
    "userCenter" : "User Center",
    "welcomeBack" : "Welcome Back",
    "continueGame" : "START",
    "officialPay" : "Top-Up Center",
    "changeAccount" : "Switch Account",
    "back" : "Back",
    "tokenKey" : "OTP",
    "inputUid" : "Enter your UID",
    "inputToken" : "Enter your OTP",
    "inputCkCode" : "Type the text",
    "enterGame" : "START",
    "tokenTip" : "Protect Your Account With OTP Verification",
    "howToGetToken" : "How to get my one-time password?",
    "getStep1" : "Step 1: Go to Settings > Account > User Center",
    "getStep2" : "Step 2: Tap OTP",
    "getStep3" : "Step 3: Copy and enter your UID and one-time password",
    "copy" : "Copy",
    "lastRefresh" : "Refreshes in:",
    "second" : "s",
    "immediatelyRefresh" : "Refresh Now",
    "frequently" : "Operation too frequent. Please try again later.",
    "loginFail" : "Login failed. Incorrect password.",
    "tokenIntro" : "About One-Time Password (OTP)",
    "tokenIntro1" : "1. One-time passwords expire in 120 seconds. Use them wisely to keep your account safe and secure.",
    "tokenIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "nextStep1" : "Confirme",
    "couponCanUse" : "Utilizável",
    "couponCanNotUse" : "Inutilizável",
    "couponHasNoCoupon" : "Sem cupons",
    "couponUseTip" : "Use 1 cupom para cada pedido",
    "couponValidTime" : "Validade",
    "couponFuilCanUse" : "Utilizável para pedidos acima de \${price} \${currency}",
    "couponNoLimit" : "Sem limitações",
    "couponAllProductCanUse" : "Todos os itens",
    "couponPartProductCanUse" : "Itens específicos",
    "couponPartPaytypeCanUse" : "Canais de pagamento específicos",
    "couponOnlyCoinCanUse" : "Apenas para moeda do jogo",
    "couponOnlyDiamondCanUse" : "Apenas para diamantes",
    "couponOnlyPackageCanUse" : "Apenas para pacotes",
    "couponOnlySubCanUse" : "Apenas para assinaturas",
    "couponOnlyDaibiCanUse" : "Apenas para fichas",
    "couponMaxDiscount" : "Desconto de até \${price} \${currency}",
    "couponHasUsed" : "Usado",
    "couponReductionType" : "Dedução",
    "couponDiscountType" : "Desconto",
    "couponUseNow" : "Usar",
    "couponHasNoSelect" : "Não está usando cupom",
    "couponHasSelectQuan" : "Desconto",
    "couponSubmitTip" : "Os cupons serão usados",
    "couponCanUseQuan" : "Cupons",
    "couponOrderTotal" : "Total",
    "couponHasDiscount" : "Desconto",
    "couponPayTotal" : "Pagamento",
    "couponCancel" : "Cancelar",
    "couponConfirm" : "Confirmar",
    "uidLoginName" : "Log in with OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "Enter your UID",
    "uidInputToken" : "Enter your OTP",
    "uidInputCode" : "Type the text",
    "uidTipTitle" : "Protect Your Account With OTP Verification",
    "uidTipHowToGet" : "How to get my one-time password?",
    "uidTipStep1" : "Step 1: Go to Settings > Account > User Center",
    "uidTipStep2" : "Step 2: Tap OTP",
    "uidTipstep3" : "Step 3: Copy and enter your UID and one-time password",
    "uidTipIntro1" : "1. One-time passwords expire in 60 seconds. Use them wisely to keep your account safe and secure.",
    "uidTipIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "couponMyQuan" : "Cupons",
    "couponSelectPaytypeTip" : "Selecione o canal de pagamento para ver as informações de desconto",
    "couponSelectCouponTip" : "Selecione cupons para ver o preço com desconto",
    "couponValidQuanTip" : "(cupom x\${num} utilizável)",
    "couponLookCart" : "Carrinho",
    "couponUnfoldCart" : "Esconder",
    "couponCoupon" : "Cupom",
    "couponNoUse" : "Não está usando",
    "couponSelect" : "Selecionar Cupom",
    "couponSureUse" : "Usar",
    "couponReturn" : "Voltar",
    "couponInvalidTime" : "Expira em",
    "couponBuyNow" : "Comprar Agora",
    "couponAllType" : "all",
    "ztmslgType1" : "Promoção Diária",
    "ztmslgType2" : "Herói",
    "ztmslgType3" : "Equipamento de Batalha",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Recurso",
    "ztmslgType8" : "Aceleração de Construção",
    "ztmslgType9" : "Itens Raros",
    "ztmslgType10" : "Aliança",
    "ztmslgType11" : "Diamante",
    "ztmslgType12" : "Módulo",
    "ztmslgType13" : "Cubo",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanoarma",
    "ztmslgType16" : "Grande Prêmio",
    "ztmslgType17" : "Núcleo",
    "ztmslgType9999" : "Oferta limitada",
    "ztmslgType10000" : "Centro de Presentes",
    "ztmslgType10001" : "Eventos de Festividades",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Promoção Diária",
    "antslgType2" : "Formiga Especializada",
    "antslgType3" : "Equip",
    "antslgType5" : "Gene",
    "antslgType6" : "Caracol",
    "antslgType7" : "Recursos",
    "antslgType8" : "Obras & Pesquisa",
    "antslgType9" : "Itens Raros",
    "antslgType10" : "Aliança",
    "antslgType11" : "Diamante",
    "antslgType12" : "Célula",
    "antslgType13" : "Totem",
    "antslgType9999" : "Oferta Limitada",
    "antslgTypeother" : "other",
    "typeall" : "Todos os produtos",
    "vipHead" : "Pontos VIP",
    "vipHead213": "Associação Premium",
    "vipTitle" : "Evento de Pontos VIP",
    "nowLevel" : "Seu nivel:",
    "myVipScore" : "Seus pontos:",
    "nextLevelNeed" : "(Ganhe \${num} mais pontos para obter VIP \${level})",
    "ruleTitle" : "Regras:",
    "ztmslgVipRule1" : "1. O evento começa às 00:00 (UTC) 22/09/2022",
    "ztmslgVipRule2" : "2. Jogos disponíveis:  Puzzles & Survival",
    "ztmslgVipRule3" : "Cada tipo de recompensa de evento só pode ser reivindicada uma vez.",
    "ztmslgVipRule4" : "3. Evento de Cupom de Login: ao fazer login na página de recarga pela primeira vez, você poderá resgatar um cupom de desconto de 15%.",
    "ztmslgVipRule5" : "4. Evento de Pontos VIP: compre itens através de nossa página oficial para ganhar pontos e obter cupons de nível e cupons semanais.",
    "ztmslgVipRule6" : "5. Os pontos que você pode ganhar podem variar de acordo com a moeda que você está usando. Para mais detalhes, verifique o link na parte inferior.",
    "ztmslgVipRule7" : "6. Ao usar cupons, você ganhará pontos com base no valor pago após a dedução dos cupons.",
    "ztmslgVipRule8" : "7. Os pontos que você ganhou expiram em 365 dias. Isso pode afetar seu nível VIP.",
    "ztmslgVipRule9" : "8. Você receberá imediatamente um cupom por atingir um nível VIP pela primeira vez. O cupom semanal será resgatável às 00:00 (UTC+0) todos os sábados.",
    "ztmslgVipRule10" : "9. Você precisará fazer login para reivindicar o cupom semanal. Não perca!",
    "ztmslgVipRule11" : "10. A moeda do cupom será a moeda do último pedido que você fez. Entre em contato com nosso serviço ao cliente se desejar alterar a moeda que está usando.",
    "ztmslgVipRule12" : "11. Consulte a tabela abaixo para obter mais detalhes sobre os níveis e cupons VIP.",
    "ztmslgVipRule13" : "12. Em caso de qualquer disputa, a equipe de suporte da Puzzles & Survival tem o único e final critério de interpretação destes Termos e Condições.",
    "vipLevel" : "Nível VIP",
    "vipCondition" : "Pontos necessários",
    "firstSend" : "Primeira vez alcançando o presente",
    "weeklySend" : "Cupom semanal",
    "lastAllCoupon" : "Cupons do nível anterior",
    "besides" : "Tabela de moedas/pontos:",
    "couponRatio" : "Taxa de moeda/pontos",
    "backToPay" : "VOLTAR",
    "quanGift" : "CUPOM",
    "quanGiftTips" : "Você tem cupom(s) resgatável(is)!",
    "antslgVipRule1" : "Devido a uma atualização de recurso, o evento \"Pontos VIP\" será descontinuado em breve.",
    "antslgVipRule2" : "Não se esqueça de usar os cupons obtidos no evento \"Pontos VIP\" antes que eles expirem.",
    "antslgVipRule3" : "Horário de término: 28/09/2024 00:00:00 (UTC)",
    "antslgVipRule4" : "Após o término do evento, você pode visitar o Centro de Membros Premium para aproveitar mais benefícios:",
    "antslgVipRule5" : "Complete missões para ganhar pontos, que podem ser trocados por cupons, itens no jogo e outras recompensas! Aproveite benefícios exclusivos para membros e sorteios.",
    "antslgVipRule6" : "Fique ligado para mais recompensas e eventos!",
    "dzgVipRule0" : "1. O evento começa às 00:00 (UTC) 27/09/2022",
    "dzgVipRule1" : "1. Jogos disponíveis: \${gameName}",
    "dzgVipRule2" : "Cada tipo de recompensa de evento só pode ser reivindicada uma vez.",
    "dzgVipRule3" : "2. Evento de Cupom de Login: ao fazer login na página de recarga pela primeira vez, você poderá resgatar um cupom de desconto de 15%.",
    "dzgVipRule4" : "3. Evento de Pontos VIP: compre itens através de nossa página oficial para ganhar pontos e obter cupons de nível e cupons semanais.",
    "dzgVipRule5" : "4. Os pontos que você pode ganhar podem variar de acordo com a moeda que você está usando. Para mais detalhes, verifique o link na parte inferior.",
    "dzgVipRule6" : "5. Ao usar cupons, você ganhará pontos com base no valor pago após a dedução dos cupons.",
    "dzgVipRule7" : "6. Os pontos que você ganhou expiram em 365 dias. Isso pode afetar seu nível VIP.",
    "dzgVipRule8" : "7. Você receberá imediatamente um cupom por atingir um nível VIP pela primeira vez. O cupom semanal será resgatável às 00:00 (UTC+0) todos os sábados.",
    "dzgVipRule9" : "8. Você precisará fazer login para reivindicar o cupom semanal. Não perca!",
    "dzgVipRule10" : "9. A moeda do cupom será a moeda do último pedido que você fez. Entre em contato com nosso serviço ao cliente se desejar alterar a moeda que está usando.",
    "dzgVipRule11" : "10. Consulte a tabela abaixo para obter mais detalhes sobre os níveis e cupons VIP.",
    "dzgVipRule12" : "11. Em caso de qualquer disputa, a equipe de suporte da \${gameName} tem o único e final critério de interpretação destes Termos e Condições.",
    "213dzgVipRule1" : "Devido a uma atualização de recurso, o evento \"Pontos VIP\" será descontinuado em breve.",
    "213dzgVipRule2" : "Não se esqueça de usar os cupons obtidos no evento \"Pontos VIP\" antes que eles expirem.",
    "213dzgVipRule3" : "Horário de término: 19/08/2024 08:00:00 (UTC)",
    "213dzgVipRule4" : "Após o término do evento, você pode visitar o Centro de Membros Premium para aproveitar mais benefícios:",
    "213dzgVipRule5" : "Complete missões para ganhar pontos, que podem ser trocados por cupons, itens no jogo e outras recompensas! Aproveite benefícios exclusivos para membros e sorteios.",
    "213dzgVipRule6" : "Fique ligado para mais recompensas e eventos!",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Vincular/Desvincular conta",
    "unbindApply" : "Desvincular",
    "unbindConfirmTitle" : "Tem certeza de que deseja desvincular a conta?",
    "unbindConfirmTip" : "Desvincular a conta pode levar à perda de salvamento/progresso do jogo.",
    "unbindConfirm" : "Desvincular assim mesmo",
    "unbindExit" : "Sair",
    "unbindSucc" : "Conta desvinculada",
    "unbindFail" : "Falha ao desvincular sua conta. Entre em contato com o Atendimento ao Cliente.",
    "unbindServiceTitle" : "Solicite uma operação de desvinculação manual.",
    "unbindContact" : "Atendimento ao Cliente",
    "unbindServiceTip" : "Você não pode desvincular sua conta. Entre em contato com o Atendimento ao Cliente.",
    "antslgType15" : "Legado",
    "shareEventTitle" : "Convide amigos</br>Ganhe Recompensas",
    "shareRule" : "Regras",
    "awardBag" : "Minha recompensa",
    "initiatorText" : "Eu sou um convidador",
    "inviteeText" : "Eu sou um convidado",
    "createCode" : "Criar código de convite",
    "createCodeTip" : "Toque para criar um código de convite",
    "createLinkTip" : "Toque para criar um link de convite",
    "copyText" : "cópia de",
    "shareCode" : "Compartilhar código de convite",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Ver recompensa",
    "seeAwardTip" : "Verifique suas recompensas em <span class=\"see-light\">Ponto VIP</span> > <span class=\"see-light\">Meu cupom</span>.",
    "inviteReward" : "Prêmio de convite",
    "inviteRewardTip" : "O convidador só pode reivindicar essas recompensas quando cada convidado atingir essas metas pela primeira vez",
    "overweightReward" : "Recompensa de bônus",
    "resetTip" : "Reinicia às 00:00 do último dia de cada mês.",
    "rewardText1" : "Recarga total pelo convidado: \$ 9,99",
    "rewardText2" : "Recarga total pelo convidado: \$ 49,99",
    "rewardText3" : "Recarga total pelo convidado: \$ 99,99",
    "rewardText4" : "Ganhe cupom de 12% OFF x1 para cada 5 jogadores convidados",
    "rewardText5" : "Receba um cupom de 15% de desconto x1 depois que seus convidados recarregarem um total de \$ 1.000",
    "invitationList" : "Meu convite",
    "refresh" : "Atualizar",
    "invitedTotal" : "Convidamos: \${total}",
    "storedTotal" : "Recarga total: \${total}",
    "people" : "",
    "invitedPeople" : "Convidado",
    "invitedTime" : "Convidado",
    "got" : "Alcançou",
    "get" : "Não alcançado",
    "overlay" : "Empilhável",
    "couponText" : "Cupom",
    "personalReward" : "Recompensa de recarga",
    "personalRewardText1" : "Total de recarga atinge US \$ 9,99",
    "personalRewardText2" : "Total de recarga atinge US \$ 49,99",
    "personalRewardText3" : "Total de recarga atinge US \$ 99,99",
    "inputCode" : "Digite o código de convite",
    "bindCode" : "confirme",
    "bindSucc" : "Vinculado",
    "codeTip1" : "Código não existe.",
    "codeTip2" : "Vincular Código de Convite",
    "copySucc" : "Sucesso!",
    "awardName" : "Recompensa",
    "getTime" : "Obtido",
    "getCondition" : "Requerimento",
    "couponText1" : "Cupom de 6% de desconto",
    "couponText2" : "Cupom de 8% de desconto",
    "couponText3" : "Cupom de 10% de desconto",
    "couponText4" : "Cupom de 12% de desconto",
    "couponText5" : "Cupom de 15% de desconto",
    "ruleText1" : "1. Hora de início do evento: 25/11/2022, 00:00 UTC",
    "ruleText2" : "2. Jogo de evento: Puzzles & Survival",
    "ruleText3" : "3. Evento \"Compartilhamento oficial do site de Recarga\": Compartilhe este site oficial de recarga com seus amigos e convide-os para recarregar. Se eles recarregarem uma certa quantia através desta página, você será recompensado.",
    "ruleText4" : "4. Recompensas mensais de pagamento de terceiros: Atinja metas de compartilhamento mensais para ganhar recompensas. Recompensas de compartilhamento são redefinidas todos os meses.",
    "ruleText5" : "5. Recompensas Mensais exigem pelo menos um pagamento de recarga bem-sucedido no site de terceiros por novos jogadores que você convidou.",
    "ruleText6" : "6. As recompensas mensais são redefinidas no primeiro dia de cada mês. Isso também redefine qualquer progresso do mês anterior.",
    "ruleText7" : "7. O cupom premiado deve ser reivindicado ao fazer login no site de recarga de terceiros. Você não receberá outro cupom se ele tiver expirado.",
    "ruleText8" : "8. O cupom usa a mesma moeda que você usou em recargas anteriores bem-sucedidas.",
    "ruleText9" : "9. Você não pode usar o código de convite de outro jogador se ele já tiver usado o seu.",
    "ruleTableTitle1" : "Regras：",
    "ruleTableTitle2" : "Níveis VIP e Cupons Explicados:",
    "ruleTableHead1" : "Requisito de Recarga",
    "ruleTableHead2" : "Requisito de Recompensas",
    "ruleTableHead3" : "Recompensas",
    "ruleTableContent1" : "Convide 5 novos jogadores",
    "ruleTableContent2" : "Jogadores convidados recarregam \$ 1.000 USD",
    "errorTip" : "Falha na operação",
    "eventShareText1" : "Ofertas por tempo limitado de Puzzles & Survival",
    "eventShareText2" : "Muitos presentes aguardam!",
    "cartDoubleTip" : "Multiplicadores de caixa não são suportados.",
    "codeTip3" : "Não logado",
    "codeTip4" : "Parâmetro ausente",
    "codeTip5" : "Não é possível vincular seu próprio código de convite",
    "codeTip6" : "Código de convite criado",
    "payWelfare" : "Presente de recarga",
    "wallet" : "Carteira",
    "myDiscount" : "Meu cupom",
    "knowMore" : "Mais",
    "backPay" : "De volta",
    "curBalance" : "Equilíbrio",
    "pay" : "Completar",
    "changeCoin" : "Trocar moeda",
    "watchDesc" : "Ver detalhes",
    "getMore" : "Pegue mais",
    "getDiscount" : "Reivindique seus cupons",
    "notOpenDiscountQuan" : "Sem eventos. Por favor fique atento!",
    "abountZbit" : "Sobre \${Z-BIT}",
    "remain" : "Deixei:",
    "payRemain" : "Valor restante após a compra:",
    "payRemainExpiry" : "Após o pagamento, o saldo estimado é de ${money} (expira em 1 de janeiro de 2026, por favor, use-o o mais rápido possível)",
    "balanceNotEnoughExpiry" : "Saldo insuficiente (expira em 1 de janeiro de 2026, recarga não suportada)",
    "balanceNotEnoggh" : "Não há equilíbrio suficiente. Por favor, complete primeiro.",
    "goToPay" : "Completar",
    "chooseOtherPay" : "Outros métodos de pagamento",
    "payIntro" : "Detalhes de recarga",
    "logRole" : "Selecionar personagem",
    "chooseProduct" : "Selecionar itens",
    "meAgree" : "Eu li e concordo com os termos.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "A verificação dinâmica é necessária antes de usar \${Z-BIT}",
    "dl3dvnVipRule1" : "1. Jogos disponíveis: \${gameName}",
    "dl3dvnVipRule2" : "Cada tipo de recompensa de evento só pode ser reivindicada uma vez.",
    "dl3dvnVipRule3" : "2. Evento de Cupom de Login: ao fazer login na página de recarga pela primeira vez, você poderá resgatar um cupom de desconto de 15%.",
    "dl3dvnVipRule4" : "3. Evento de Pontos VIP: compre itens através de nossa página oficial para ganhar pontos e obter cupons de nível e cupons semanais.",
    "dl3dvnVipRule5" : "4. Os pontos que você pode ganhar podem variar de acordo com a moeda que você está usando. Para mais detalhes, verifique o link na parte inferior.",
    "dl3dvnVipRule6" : "5. Ao usar cupons, você ganhará pontos com base no valor pago após a dedução dos cupons.",
    "dl3dvnVipRule7" : "6. Os pontos que você ganhou expiram em 365 dias. Isso pode afetar seu nível VIP.",
    "dl3dvnVipRule8" : "7. Você receberá imediatamente um cupom por atingir um nível VIP pela primeira vez. O cupom semanal será resgatável às 00:00 (UTC+0) todos os sábados.",
    "dl3dvnVipRule9" : "8. Você precisará fazer login para reivindicar o cupom semanal. Não perca!",
    "dl3dvnVipRule10" : "9. A moeda do cupom será a moeda do último pedido que você fez. Entre em contato com nosso serviço ao cliente se desejar alterar a moeda que está usando.",
    "dl3dvnVipRule11" : "10. Consulte a tabela abaixo para obter mais detalhes sobre os níveis e cupons VIP.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. Em caso de qualquer disputa, a equipe de suporte da \${gameName} tem o único e final critério de interpretação destes Termos e Condições.",
    "codeTip7" : "Não é possível usar o código do jogador alvo porque ele já usou o seu",
    "ruleText10" : "10. A gerência oficial de Puzzles & Survival reserva-se qualquer direito de interpretação final.",
    "payCoins" : "Ponto VIP de recarga",
    "shareGift" : "Shae para presentes",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "Não há métodos de pagamento disponíveis na região selecionada. Por favor, mude a região e tente novamente.",
    "dl3dtwVipRule1" : "1. Jogos disponíveis: \${gameName}",
    "dl3dtwVipRule2" : "Cada tipo de recompensa de evento só pode ser reivindicada uma vez.",
    "dl3dtwVipRule3" : "2. Evento de Pontos VIP: compre itens através de nossa página oficial para ganhar pontos e obter cupons de nível e cupons semanais.",
    "dl3dtwVipRule4" : "3. Os pontos que você pode ganhar podem variar de acordo com a moeda que você está usando. Para mais detalhes, verifique o link na parte inferior.",
    "dl3dtwVipRule5" : "4. Ao usar cupons, você ganhará pontos com base no valor pago após a dedução dos cupons.",
    "dl3dtwVipRule6" : "5. Os pontos que você ganhou expiram em 365 dias. Isso pode afetar seu nível VIP.",
    "dl3dtwVipRule7" : "6. Você receberá imediatamente um cupom por atingir um nível VIP pela primeira vez. O cupom semanal será resgatável às 00:00 (UTC+0) todos os sábados.",
    "dl3dtwVipRule8" : "7. Você precisará fazer login para reivindicar o cupom semanal. Não perca!",
    "dl3dtwVipRule9" : "8. A moeda do cupom será a moeda do último pedido que você fez. Entre em contato com nosso serviço ao cliente se desejar alterar a moeda que está usando.",
    "dl3dtwVipRule10" : "9. Consulte a tabela abaixo para obter mais detalhes sobre os níveis e cupons VIP.",
    "dl3dtwVipRule11" : "10. Em caso de qualquer disputa, a equipe de suporte da \${gameName} tem o único e final critério de interpretação destes Termos e Condições.",
    "eventInviteSucc" : "Convidou um amigo com sucesso",
    "eventGainCondition" : "Requisitos",
    "eventSuccInvite" : "Convide um amigo com sucesso",
    "eventInviteGainOne" : "Recarga total pelo \nconvidado: \$ 49,99",
    "eventInviteGainTwo" : "Recarga total pelo \nconvidado: \$ 99,99",
    "eventFriendCode" : "Código do seu amigo:",
    "eventCheckBind" : "Vincular?",
    "eventConfirm" : "Confirmar",
    "eventCancel" : "Cancelar",
    "eventBindSucc" : "Vinculado com sucesso!",
    "eventGainCoupon" : "Você obteve um cupom.",
    "eventLookCoupon" : "Ver cupom",
    "eventSuccBind" : "Vinculado com sucesso",
    "recaptchaTip" : "Verifique primeiro",
    "completeRecaptcha" : "Conclua a verificação captcha",
    "recaptchaExpired" : "A verificação expirou, tente novamente",
    "inputAccountName" : "Insira a conta que deseja recuperar",
    "pwaPayTip" : "Acesso rápido, melhor experiência",
    "pwsInstall" : "Adicionar à Tela de Início",
    "ztmslgType999" : "Voucher",
    "coinUseTips" : "Após a compra, os Vouchers serão enviados para as suas mensagens no jogo. Os vouchers podem ser usados para comprar itens do Shopping de Voucher no jogo. Os vouchers usados para comprar itens contarão para a sua recarga total.",
    "notice" : "Aviso",
    "popupConfirm" : "Confirmar",
    "hideWithinWeek" : "Não exibir novamente por 7 dias",
    "ztmslgProductOffTips" : "Recebemos muitos comentários sobre as alterações na página de pagamento que deveriam ter sido implementadas em 13 de março. Em resposta a isso, decidimos cancelar essas mudanças e nos concentrar na melhoria da sua experiência de compra. Agradecemos suas opiniões e agradecemos por sua compreensão e apoio. Se tiver outras perguntas, não hesite em entrar em contato com nossa equipe de Suporte ao Cliente.",
    "couponTopLimit" : "Valores máximos dedutíveis por moeda",
    "swsjpVipRule1" : "1. O evento começa às 00:00 (UTC) 24/03/2023",
    "swsjpVipRule2" : "2. Jogos disponíveis: \${gameName}",
    "swsjpVipRule3" : "Cada tipo de recompensa de evento só pode ser reivindicada uma vez.",
    "swsjpVipRule4" : "3. Evento de Cupom de Login: ao fazer login na página de recarga pela primeira vez, você poderá resgatar um cupom de desconto de 15%.",
    "swsjpVipRule5" : "4. Evento de Pontos VIP: compre itens através de nossa página oficial para ganhar pontos e obter cupons de nível e cupons semanais.",
    "swsjpVipRule6" : "5. Os pontos que você pode ganhar podem variar de acordo com a moeda que você está usando. Para mais detalhes, verifique o link na parte inferior.",
    "swsjpVipRule7" : "6. Ao usar cupons, você ganhará pontos com base no valor pago após a dedução dos cupons.",
    "swsjpVipRule8" : "7. Você já recebe pontos por compras feitas anteriormente.",
    "swsjpVipRule9" : "8. Os pontos que você ganhou expiram em 365 dias. Isso pode afetar seu nível VIP.",
    "swsjpVipRule10" : "9. Você receberá imediatamente um cupom por atingir um nível VIP pela primeira vez. O cupom semanal será resgatável às 00:00 (UTC+0) todos os sábados.",
    "swsjpVipRule11" : "10. Você precisará fazer login para reivindicar o cupom semanal. Não perca!",
    "swsjpVipRule12" : "11. A moeda do cupom será a moeda do último pedido que você fez. Entre em contato com nosso serviço ao cliente se desejar alterar a moeda que está usando.",
    "swsjpVipRule13" : "12. Em caso de qualquer disputa, a equipe de suporte da \${gameName} tem o único e final critério de interpretação destes Termos e Condições.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Voucher",
    "passAskMods" : "Perguntar ao Mod",
    "passAskModsTip" : "Faça perguntas aos moderadores sobre o jogo",
    "passService" : "Consulta do Cliente",
    "passServiceTip" : "Para qualquer dúvida sobre conta e recarga, entre em contato com nosso atendimento ao cliente.",
    "passIKonw" : "Ok",
    "passGoOn" : "Continuar",
    "voucherTitle" : "Centro Oficial de Recarga",
    "voucherAddHome" : "Adicionar à Área de Trabalho",
    "voucherAddHomeTipOne" : "Pagamento mais rápido, experiência melhor",
    "voucherAddHomeTipTwo" : "Toque em [Compartilhar] na barra de ferramentas",
    "voucherAddHomeTipThree" : "Selecione [Adicionar à Área de Trabalho]",
    "voucherLoginLook" : "Faça login para ver as ofertas",
    "voucherSwitchRole" : "Alternar Personagem",
    "voucherCoupon" : "Cupom",
    "voucherVip" : "Ponto VIP",
    "voucherMoreCoupon" : "Mais Ofertas",
    "voucherAccountId" : "ID da conta",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "Escolha outra forma de pagamento",
    "voucherOtherLoginWay" : "Tentar de outra maneira",
    "voucherCouponActivity" : "Desconto de promoções",
    "voucherActivityNotBegin" : "Evento ainda não iniciado.",
    "voucherGoCommunity" : "Saiba mais sobre os benefícios de recarga na comunidade",
    "voucherValidTime" : "Validade",
    "voucherLimitRegion" : "Apenas para \${currency}",
    "voucherLiuyi" : "Nenhum cupom disponível. Preste atenção aos eventos futuros.",
    "voucherPay" : "Comprar Vouchers",
    "voucherAbout" : "Sobre o Voucher",
    "voucherChooseWay" : "Selecione o método de pagamento",
    "voucherMoreWay" : "Mais métodos de pagamento",
    "voucherChooseCoupon" : "Selecionar cupom",
    "voucherHasChoose" : "Selecionado",
    "voucherMoneyInsufficient" : "Saldo insuficiente",
    "voucherContact" : "Saldo insuficiente. Entre em contato com nossa equipe de suporte.",
    "voucherCouponTotal" : "Cupons Disponíveis",
    "voucherCouponTipGuide" : "Os cupons podem ser usados para pagamento após selecionar o canal de pagamento.",
    "voucherPaytypeNotSupport" : "Os cupons estão indisponíveis para este canal de pagamento",
    "voucherTipSideOne" : "Os vouchers podem ser trocados por todos os pacotes do jogo e serviços de valor agregado, exceto o próprio voucher.",
    "voucherTipSideTwo" : "Até 15% de desconto",
    "voucherYue" : "Saldo",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Manual de supervivencia",
    "vipHeadText" : "Quadro exclusivo VIP desbloqueado",
    "vipHeadGetText" : "Resgatar",
    "vipHeadGotText" : "Resgatado",
    "vipHeadGetTitle" : "Confirmar",
    "vipHeadGetTip" : "Esta recompensas só pode ser reivindicada uma vez por conta. Deseja continuar?",
    "vipHeadAwardText" : "Comandante de Elite (Permanente)",
    "vipHeadGetErrTip1" : "Falha. Tente novamente ou entre em contato com o SAC.",
    "cartGuideTipNew" : "Añadir más objetos para utilizar el cupón",
    "newVipTitle" : "Central de Recarga VIP",
    "newVipLogin" : "ENTRAR",
    "newVipNowPoint" : "Pontos:",
    "newVipNextLevel" : "\${point} pontos para o próximo nível",
    "newVipUpgrade" : "APRIMORAR",
    "newVipLevel" : "Privilégios VIP",
    "newVipTip" : "Os cupons serão atualizados às 00:00 (UTC) todos os sábados. Você os receberá quando fizer login na página oficial de recarga.",
    "newVipWeekly" : "Presente semanal",
    "newVipReachPoint" : "Requisitos:",
    "newVipRuleInfo" : "Regras:",
    "pleaseLang" : "Escolher um idioma",
    "reference" : "Número do pedido",
    "saveToNext" : "Salvar as informações do cartão de crédito.",
    "cardNum" : "Número do cartão",
    "expireTime" : "Válido até",
    "CVV" : "CVV",
    "pleaseCard" : "Tipo de cartão de crédito",
    "howToPay" : "Como você gostaria de pagar?",
    "checkCard" : "Verifique o número do seu cartão.",
    "checkExpiryDate" : "Verifique a data de validade do seu cartão.",
    "checkCVV" : "Verifique o CVV do seu cartão.",
    "addCard" : "Novo",
    "delete" : "Excluir",
    "deleteCardTips" : "Exclua as informações salvas do cartão de crédito.",
    "confirmDelete" : "Sim, excluir",
    "cancelDelete" : "Cancelar",
    "checkAllCardMsg" : "Certifique-se de que inseriu o número do cartão correto, data de validade e CVV.",
    "leaveCreditPageTips" : "La transaction ne sera pas effectuée si vous quittez cette page maintenant. Quitter ?",
    "sureToLeave" : "Quitter",
    "continueToPay" : "Continuer",
    "pushTest" : "Teste de Notificação",
    "getNoticication" : "Não está recebendo notificações de jogos?",
    "waitCheckResult" : "Aguarde o resultado do teste.",
    "hadAbnormal" : "Foi encontrada uma anomalia que pode levar à falha na notificação.",
    "clickIntro" : "Toque no relatório para ver a solução",
    "networkCheck" : "Teste de rede",
    "noticeAuthorityCheck" : "Teste de acesso à notificação",
    "noticeBtnCheck" : "Teste da barra de notificação",
    "gmsCheck" : "teste de serviço GMS",
    "batteryCheck" : "Teste de lista de otimização de bateria",
    "pushServiceCheck" : "Teste de serviço de notificação",
    "reCheck" : "Teste novamente",
    "noNoticeAuthorityTip" : "Acesso de notificação não concedido neste dispositivo. Vá para Configurações do sistema - Notificações para conceder acesso ao jogo.",
    "noNoticeBtnTip" : "A barra de notificação está desativada. Ative-o nas configurações do sistema.",
    "noBatteryTip" : "O jogo está na lista de otimização de bateria, você pode não receber as notificações. Vá para Configurações do sistema - Bateria - Otimização da bateria para adicionar o jogo à lista de permissões.",
    "noPushServiceTip" : "Servidor de notificação não conectado. Toque em [Conectar] para retomar o serviço.",
    "noNetworkTip" : "Sua conexão de rede atual é instável.",
    "noGmsTip" : "Seu dispositivo não suporta GMS. Use um dispositivo compatível com GMS.",
    "pushConnectFail" : "Servidor de notificação desconectado.",
    "pushConnectSucc" : "Servidor de notificação conectado.",
    "noGetPushTitle" : "Se você ainda não consegue receber notificações do jogo, siga estas etapas:",
    "noGetPushContOne" : "1. Saia do jogo e faça login novamente neste dispositivo.",
    "noGetPushContTwo" : "2. Toque em [Teste de notificação] para verificar se o seu dispositivo em uso atual pode receber a notificação de teste.",
    "noGetPushContThree" : "3. Se você recebeu a notificação de teste, mas ainda não pode receber nenhuma outra notificação, faça login no jogo, vá para Configurações - Notificações e verifique se todas as notificações estão ativadas.",
    "noGetPushContFour" : "4. Se ainda não conseguir receber nenhuma notificação, entre em contato com nosso atendimento ao cliente.",
    "getPushSucc" : "Seu dispositivo recebeu uma notificação de teste. A função está funcionando normalmente!",
    "allCheckSucc" : "Teste de notificação feito. Nenhuma anomalia foi encontrada!",
    "pushCheck" : "Teste de notificação",
    "useDirectPay" : "Usar Check-out Expresso",
    "paypalFraudnetInfo" : "Pagamento seguro via PayPal",
    "goToSetting" : "Configurações",
    "retry" : "Tentar novamente",
    "connect" : "Conectar-se",
    "canRebind" : "Você pode vincular novamente depois de desvincular",
    "agreePlatform" : "Eu concordei com o \${service} e o \${private}.",
    "sendGameNews" : "Assinar boletins informativos.",
    "canNotBindEmail" : "Você não poderá usar este e-mail para fazer login depois de desvinculá-lo.",
    "canNotBindPhone" : "Você não poderá usar este número de celular para fazer login depois de desvinculá-lo.",
    "canChangeByEmail" : "Você pode fazer login com e-mail em diferentes dispositivos.",
    "canChangeByPhone" : "Você pode fazer login com o número do celular em diferentes dispositivos.",
    "loginSucc" : "Logado",
    "phoneHadBind" : "O número do celular já foi vinculado. Entrar com ele?",
    "emailHadBind" : "O e-mail já foi vinculado. Entrar com ele?",
    "phoneNotBind" : "O número do celular ainda não foi vinculado. Criar uma nova conta?",
    "emailNotBind" : "O e-mail ainda não foi vinculado. Criar uma nova conta?",
    "emailAccount" : "Conta de e-mail",
    "phoneAccount" : "Conta de celular",
    "phoneInputError" : "Número de celular inválido",
    "registerNewAccount" : "Inscrever-se",
    "secureTip" : "Dicas de segurança para sua conta",
    "toTop" : "Fixar no topo",
    "createNewWork" : "Novo ingresso",
    "serviceEvaluate" : "Avaliar serviço",
    "emailRemind" : "Notificações",
    "isAgreeService" : "Gostou do nosso serviço?",
    "thankEvaluateTop" : "Obrigado pelo seu feedback!",
    "inputValidEmail" : "Por favor insira um endereço de e-mail válido.",
    "replyWillRemind" : "Você receberá um e-mail de notificação quando sua pergunta for respondida. Toque novamente para deativá-lo.",
    "isCancelEmailRemind" : "Você não receberá nenhum e-mail de notificação. Ainda desativá-lo?",
    "reconfirmEmail" : "Confirme seu endereço de email.",
    "confirmCanSubmit" : "Confirme para enviar o ticket",
    "serviceWillReply" : "Você será notificado por e-mail quando o atendimento ao cliente responder.",
    "cancelEmailRemind" : "Desligar [Notifications]?",
    "yes" : "Sim",
    "no" : "Não",
    "inputWorkSearch" : "Procurar…",
    "loading" : "Carregando",
    "loadingError" : "主页/ 语言包管理\n所属平台\n全球平台\n 语言包类型\nPHP数组\n 过滤\n无\n \n \n提示：按\"Tab\"键可以向下切换焦点，文本框失去焦点会自动保存，原文没有换行请不要进行换行，\n未编辑的文本框显示白色，编辑中的文本框显示蓝色，保存中的文本框显示橙色，保存失败的文本框显示红色，已保存的文本框显示灰色。\n最后修改者：[liangziyao]，修改时间：[2023-09-25 18:30:16]\n功能选项   \n语言选项                 \nID： \n3070\n-\n0\n0代表不限制\n为了提高效率，初次进入页面不显示数据，请勾选选项再点击筛选\n唯一ID	状态	通用标识	Web标识	中文(简体)	中文(繁体)	英语(美国)	日语	朝鲜语	越南语	法语(法国)	德语(德国)	葡萄牙语(葡萄牙)	西班牙语(国际)	俄语	泰语	土耳其语	意大利语(意大利)	波兰语	阿拉伯语(沙特阿拉伯)	印度尼西亚语\n完成度		14 / 14	14 / 14	1 / 14	0 / 14	1 / 14	0 / 14	1 / 14	0 / 14	0 / 14	0 / 14	0 / 14	0 / 14	1 / 14	0 / 14	0 / 14	0 / 14	0 / 14	1 / 14\n3089	\n通用\nINPUT_WORK_SERACH	\ninputWorkSearch\n请输入搜索关键字\n請輸入搜尋關鍵字\nSearch...\nキーワードを入力して探してください\n검색 키워드를 입력하세요\nHãy nhập từ khóa\nRecherche...\nSuchen ...\nProcurar…\nBuscar...\nПоиск...\nโปรดป้อนคีย์เวิร์ดที่ต้องการค้นหา\nAranıyor...\nCerca...\nSzukaj...\nبحث...\nSilakan masukkan kata kunci\n3090	\n通用\nLOADING	\nloading\n加载中\n加載中\nLoading\n読み込み中\n로딩 중\nĐang tải\nChargement\nLaden\nCarregando\nCargando\nЗагрузка...\nกำลังดาวน์โหลด\nYükleniyor\nCaricando\nŁadowanie\nجارِ التحميل\nMemuat...\n3091	\n通用\nLOADING_ERROR	\nloadingError\n加载失败，请点击重新加载...\n載入失敗，請點選重新載入...\nFailed to load. Please load again...\n読み込み失敗。タップして再読み込みしてください。\n로딩 실패. 터치해 다시 로딩하세요...\nTải thất bại, hãy tải lại...\nChargement échoué. Veuillez charger à nouveau...\nLaden fehlgeschlagen. Bitte erneut laden ...\nFallo la carga. Vuelve a cargar...\nНе удалось загрузить, повторите попытку...\nดาวน์โหลดล้มเหลว โปรดแตะเพื่อดาวน์โหลดใหม่...\n3092	\n通用\nNO_MORE	\nnoMore\n没有更多了\n3093	\n通用\nCANCEL_TO_TOP	\ncancelToTop\n取消置顶\n3094	\n通用\nEVALUATE_ONE	\nevaluateOne\n很不满意\n3095	\n通用\nEVALUATE_TWO	\nevaluateTwo\n满意\n3096	\n通用\nEVALUATE_THREE	\nevaluateThree\n一般\n3097	\n通用\nEVALUATE_FOUR	\nevaluateFour\n满意\n3098	\n通用\nEVALUATE_FIVE	\nevaluateFive\n很满意\n3099	\n通用\nCONFIRM_DEL_WORK	\nconfirmDelWorkTop\n确认删除此工单？\n3100	\n通用\nRE_REMIND_EMAIL	\nreRemindEmail\n想再次通过邮件提醒您？您可重新点击【邮箱提醒】。\n3102	\n通用\nTHANK_EVALUATE_BOTTOM	\nthankEvaluateBottom\n您的评价是提升我们服务质量的动力！\n您的評價是提升我們服務品質的動力！\n皆様の評価によってサービス品質が向上されます！\nĐánh giá của bạn là động lực để chúng tôi nâng cao dịch vụ!\nเราจะนำไปพัฒนา และปรับปรุงการบริการให้ดียิ่งขึ้น!\nPenilaian Anda adalah motivasi kami!\n3103	\n通用\nCONFIRM_DEL_WORK_BOTTOM	\nconfirmDelWorkBottom\n删除后不可回复哦～",
    "noMore" : "Nada mais",
    "cancelToTop" : "Desmarcar",
    "evaluateOne" : "Muito ruim",
    "evaluateTwo" : "Ruim",
    "evaluateThree" : "Neutro",
    "evaluateFour" : "Bom",
    "evaluateFive" : "Muito bom",
    "confirmDelWorkTop" : "Excluir este tíquete?",
    "reRemindEmail" : "Precisa de notificação por e-mail? Basta tocar no botão [Notificações] novamente.",
    "confirmWillReply" : "Confirme para concordar em ser notificado por e-mail quando o atendimento ao cliente responder.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "Um ticket excluído não pode ser recuperado.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Vídeo enviado",
    "videoUploadFail" : "Falha ao enviar vídeo",
    "videoUploadLimit" : "Faça upload de arquivos mp4 com tamanho inferior a 400 MB e não superior a 2 minutos.",
    "imageUploadSucc" : "Imagem enviada",
    "imageUploadFail" : "Falha ao carregar a imagem",
    "uploading" : "Enviando",
    "smartOrderCreate" : "Bilhete Rápido",
    "smartOrderSearch" : "Procurar",
    "smartOrderComing" : "Em breve",
    "smartOrderContactService" : "Atendimento ao Cliente",
    "smartOrderDetector" : "Assistente",
    "smartOrderDetect" : "Diagnosticar",
    "smartOrderDetecting" : "Diagnosticando",
    "smartOrderDetectTip" : "Um problema foi detectado enquanto você estava jogando. Toque em Diagnosticar para que possamos identificá-lo.",
    "smartOrderDetectTip2" : "Problema identificado. Envie um ticket para que possamos resolver isso para você!",
    "smartOrderSubmit" : "Enviar",
    "smartOrderIKnow" : "OK",
    "smartOrderConfirm" : "OK",
    "smartOrderLook" : "Visualizar",
    "smartOrderIsHelp" : "Esse artigo foi útil?",
    "smartOrderInputQuestion" : "Escreva o problema que você encontrou.",
    "smartOrderPleaseInpt" : "Digitar",
    "smartOrderPleaseChoose" : "Selecionar",
    "smartOrderStoreTime" : "Horário de recarga",
    "smartOrderInputOrder" : "Insira o número do pedido",
    "smartOrderInputPrice" : "Insira o valor do pedido",
    "smartOrderNeedHelp" : "Como posso ajudá-lo?",
    "smartOrderLookHelpTip" : "Você pode verificar o FAQ.",
    "smartOrderNoResult" : "Sem resultados. Tente outra palavra-chave.",
    "smartOrderUpdateTime" : "Horário da última edição",
    "smartOrderSelectStoreTime" : "Selecione o horário de recarga",
    "smartOrderAtlestChoose" : "Preencha pelo menos um",
    "workHomeTitle": "Centro de Atendimento ao Cliente",
    "workHomeCurServer": "Servidor atual",
    "workHomeSearchPlaceholder": "Insira palavras-chave para encontrar respostas rapidamente",
    "workHomeSelfService": "Autoatendimento",
    "selfServiceRegisterDate": "Mês de registro",
    "selfServiceSocialType": "Conta social",
    "selfServiceDeviceType": "Tipo de dispositivo",
    "selfServiceDeviceId": "ID do dispositivo",
    "selfServicePhoneModel": "Modelo do telefone",
    "selfServicePayOrder": "ID do pedido",
    "selfServicePayChannel": "Canal de pagamento",
    "selfServiceWorkId": "ID do ticket",
    "workHomeAiService": "Atendimento inteligente",
    "workHomeArtificialService": "Atendente humano",
    "workHomeServiceEntrance": "Estamos ao seu serviço",
    "pwaInstallAward" : "Adicionar atalho",
    "getMasonry" : "Resgatar Diamante",
    "addToDrawerVisit" : "Adicione um atalho para que você possa encontrá-lo novamente com facilidade.",
    "immeAddToGet" : "Adicione um atalho agora para reivindicar recompensas limitadas.",
    "add" : "Adicionar atalho",
    "talkNextTime" : "Mais tarde",
    "chooseRoleGetGift" : "Selecione seu personagem para resgatar recompensas",
    "getGiftSuccess" : "Resgatado. Vá verificar suas recompensas no jogo.",
    "dmaTitle" : "Anúncios personalizados",
    "dmaTitleSub" : "(opcional)",
    "newAdd" : "Novo",
    "smartDelete" : "Excluir",
    "wordLengthTip" : "(caracteres 0-600)",
    "areaLimitSwitchRegion" : "Mudar de região",
    "areaLimitCurrentRegionCurrency" : "Região e moeda atuais",
    "areaLimitRegion" : "Região:",
    "areaLimitCurrency" : "Moeda:",
    "areaLimitNote" : "Observação:",
    "areaLimitSwitchLimitation" : "Cada conta pode mudar de região uma vez por ano.",
    "areaLimitPostSwitchCoupon" : "Depois que sua região for trocada, a moeda dos novos cupons mudará de acordo.",
    "areaLimitRemainingSwitches" : "Tentativas de troca restantes: \${times}",
    "areaLimitNoRemainingSwitches" : "Sem tentativa de troca",
    "areaLimitUnableToSwitchThisYear" : "Você não poderá mudar de região novamente este ano.",
    "areaLimitCannotSwitch" : "Não é possível mudar",
    "areaLimitNavigateToSwitch" : "Trocar",
    "areaLimitConfirmSwitch" : "Confirmar",
    "areaLimitPreSwitchRegionCurrency" : "Região e moeda atuais",
    "areaLimitPostSwitchRegionCurrency" : "Nova região e moeda",
    "areaLimitPostSwitchRestriction" : "Uma vez feito isso, você não poderá mudar de região novamente este ano.",
    "areaLimitUnusedZBitWarning" : "Você tem Z-Bit não utilizado que não pode ser usado após mudar de região.Deseja prosseguir mesmo assim?",
    "areaLimitConfirm" : "Confirmar",
    "areaLimitCancel" : "Cancelar",
    "areaLimitInconsistencyWarning" : "Sua região de acesso é inconsistente com sua região de pagamento.",
    "areaLimitPromptToSwitch" : "Deseja mudar de região?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Resgatar Recompensa",
    "selectProductTitle" : "Selecionar item",
    "hotSuggest" : "Imperdível",
    "inputKeywordSearch" : "Procurar…",
    "lookProductContent" : "Detalhes",
    "popupClose" : "Fechar",
    "productSwitch" : "Alternar",
    "confirmBuy" : "Comprar",
    "thinkLater" : "Mais tarde",
    "areaLimitConfirmRegion" : "Confirmar região",
    "areaLimitContinuePay" : "Continuar a pagar",
    "areaLimitSwitchLimitationTwice" : "Cada conta pode mudar de região duas vezes por ano.",
    "dtmslgVipRule1" : "1. Jogos disponíveis: \${gameName}",
    "dtmslgVipRule2" : "Cada tipo de recompensa de evento só pode ser reivindicada uma vez.",
    "dtmslgVipRule3" : "2. Evento de Pontos VIP: compre itens através de nossa página oficial para ganhar pontos e obter cupons de nível e cupons semanais.",
    "dtmslgVipRule4" : "3. Os pontos que você pode ganhar podem variar de acordo com a moeda que você está usando. Para mais detalhes, verifique o link na parte inferior.",
    "dtmslgVipRule5" : "4. Ao usar cupons, você ganhará pontos com base no valor pago após a dedução dos cupons.",
    "dtmslgVipRule6" : "5. Os pontos que você ganhou expiram em 365 dias. Isso pode afetar seu nível VIP.",
    "dtmslgVipRule7" : "6. Você receberá imediatamente um cupom por atingir um nível VIP pela primeira vez. O cupom semanal será resgatável às 00:00 (UTC+0) todos os sábados.",
    "dtmslgVipRule8" : "7. Você precisará fazer login para reivindicar o cupom semanal. Não perca!",
    "dtmslgVipRule9" : "8. A moeda do cupom será a moeda do último pedido que você fez. Entre em contato com nosso serviço ao cliente se desejar alterar a moeda que está usando.",
    "dtmslgVipRule10" : "9. Consulte a tabela abaixo para obter mais detalhes sobre os níveis e cupons VIP.",
    "dtmslgVipRule11" : "10. Em caso de qualquer disputa, a equipe de suporte da \${gameName} tem o único e final critério de interpretação destes Termos e Condições.",
    "dtmslgType10010" : "DESCONTO DIÁRIO",
    "dtmslgType10020" : "Oferta limitada",
    "dtmslgType10030" : "HERÓI",
    "dtmslgType10040" : "EQUIPAMENTO",
    "dtmslgType10050" : "RUNA",
    "dtmslgType10060" : "TOTEM",
    "dtmslgType10070" : "PEDRA SAGRADA",
    "dtmslgType10080" : "DRAGÃO",
    "dtmslgType10090" : "RECURSOS",
    "dtmslgType10100" : "CONSTRUÇÃO E TECNOLOGIA",
    "dtmslgType10110" : "ITENS RAROS",
    "dtmslgType10120" : "Artefatos",
    "dtmslgType10130" : "DIAMANTE",
    "dtmslgType10140" : "Voucher",
    "dtmslgType2" : "Pacote de Evento",
    "dtmslgType3" : "Centro de Recompensas",
    "dtmslgType4" : "Pacote de Aparição",
    "dtmslgType5" : "Pacote de Tela Principal",
    "dtmslgType20010" : "Pacote de Black Friday",
    "dtmslgType20021" : "Presente de 5 dias",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "Devido a uma atualização de recurso, o evento \"Pontos VIP\" será descontinuado em breve.\n" +
        "Não se esqueça de usar os cupons obtidos no evento \"Pontos VIP\" antes que eles expirem.\n" +
        "Horário de término: 19/08/2024 08:00:00 (UTC)\n" +
        "Após o término do evento, você pode visitar o Centro de Membros Premium para aproveitar mais benefícios:\n" +
        "Complete missões para ganhar pontos, que podem ser trocados por cupons, itens no jogo e outras recompensas! Aproveite benefícios exclusivos para membros e sorteios.\n" +
        "Fique ligado para mais recompensas e eventos!",
    "263RightsIntro": "Devido a uma atualização de recurso, o evento \"Pontos VIP\" será descontinuado em breve.\n" +
        "Não se esqueça de usar os cupons obtidos no evento \"Pontos VIP\" antes que eles expirem.\n" +
        "Horário de término: 28/09/2024 00:00:00 (UTC)\n" +
        "Após o término do evento, você pode visitar o Centro de Membros Premium para aproveitar mais benefícios:\n" +
        "Complete missões para ganhar pontos, que podem ser trocados por cupons, itens no jogo e outras recompensas! Aproveite benefícios exclusivos para membros e sorteios.\n" +
        "Fique ligado para mais recompensas e eventos!",
    "goToRights" : "Vá até o Centro de Membro Premium",
    "oldVipIntro" : "Não se esqueça de usar os cupons obtidos no evento \"Pontos VIP\" antes que eles expirem.",
    "pwa-20001" : "Faça o login primeiro",
    "pwa-20002" : "Parâmetro incorreto",
    "pwa-20003" : "Designe um personagem",
    "pwa-20004" : "Falha ao enviar recompensas. Tente novamente ou entre em contato com o Suporte ao Cliente.",
    "pwa-20005" : "Você já reivindicou a recompensa.",
    "pwa-20100" : "O evento não começou.",
    "pwa-20101" : "O evento terminou.",
    "pwa-20102" : "Suas recompensas expiraram.",
    "pwa-20103" : "Você ainda não pode reivindicar as recompensas.",
    "pwa-1001" : "Operação muito frequente",
    "pwaCommon" : "Tente novamente mais tarde!",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Centro Oficial de Recarga",
    "headerSafeTip": "Seguro e Livre de Riscos Transação Instantânea",
    "safeChecking": "...analisando o ambiente de pagamento",
    "safeChecked": "Seguro, confiável para usar",
    "riskChecked": "Risco potencial detectado, prossiga com cautela",
    "footerSafeTitle1": "Seguro",
    "footerSafeTitle2": "Conveniente",
    "footerSafeTitle3": "Econômico",
    "footerSafeTitle4": "Eficiente",
    "footerSafeContent1": "Centro Oficial de Recarga",
    "footerSafeContent2": "Suporta vários métodos de pagamento",
    "footerSafeContent3": "Ofertas com desconto, mais benefícios por tempo limitado",
    "footerSafeContent4": "Transação instantânea, sem atraso",
    "limitedTimeActivityTitle" : "Benefícios por tempo limitado",
    "limitedTimeActivityTime" : "Duração do Evento:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(No momento \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(As taxas de troca podem variar. Consulte esta página para informações precisas.)",
    "limitedTimeActivityNotAchieve" : "Não concluído",
    "limitedTimeActivityClaim" : "Reivindicar",
    "limitedTimeActivityClaimed" : "Reivindicado",
    "limitedTimeActivityTimeLeft" : "Tempo limitado: \${days}d \${hours}h \${minutes}m \${seconds}s",
    "limitedTimeActivityRecord" : "Reivindicar registros",
    "limitedTimeActivityAward" : "Recompensas",
    "limitedTimeActivityGotTime" : "Tempo reivindicado",
    "limitedTimeActivityGotRole" : "Personagem reivindicado",
    "limitedTimeActivityRule" : "Regras do Evento",
    "limitedTimeActivity285Rule1" : "1. Duração do Evento:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Durante o evento, conclua tarefas por tempo limitado para reivindicar recompensas. As tarefas são categorizadas em semanais e mensais:",
    "limitedTimeActivity285Rule3" : "(1) Tarefas Semanais: cada conta pode concluir apenas uma tarefa semanal por semana. Redefinem-se toda segunda às 0:00.",
    "limitedTimeActivity285Rule4" : "Tarefa Semanal de Login: dentro do tempo limitado, faça login na página de recarga do site oficial uma vez.",
    "limitedTimeActivity285Rule5" : "Recarregue qualquer quantia: dentro do tempo limitado, recarregue qualquer quantia pelo site oficial.",
    "limitedTimeActivity285Rule6" : "(2) Tarefas Mensais: cada conta pode concluir apenas uma tarefa mensal por mês. Redefinem-se no 1º dia de cada mês às 0:00.",
    "limitedTimeActivity285Rule7" : "Tarefa de Login: dentro do tempo limitado, faça login na página de recarga do site oficial uma vez.",
    "limitedTimeActivity285Rule8" : "Tarefa de Recarga Cumulativa: dentro do tempo limitado, recarregue a quantia necessária para reivindicar uma recompensa uma vez.",
    "limitedTimeActivity285Rule9" : "Observação: devido à longa duração do evento, as taxas de troca podem variar. Consulte a quantia exibida na página para ver a quantia de recarga.",
    "limitedTimeActivity285Rule10" : "3. Selecione um personagem antes de reivindicar uma recompensa. Você pode encontrar suas recompensas no jogo após reivindicá-las.",
    "limitedTimeActivityClaimAward" : "Reivindicar recompensa",
    "limitedTimeActivityConfirmGot" : "Confirmar reivindicação",
    "limitedTimeActivityGetSucc" : "Reivindicação bem-sucedida",
    "limitedTimeActivityGetFail" : "A reivindicação falhou. Tente novamente mais tarde ou entre em contato com o atendimento ao cliente.",
    "limitedTimeActivityFrequent" : "Evite ações frequentes.",
    "limitedTimeActivityLoginFirst" : "Faça login primeiro.",
    "limitedTimeActivityWrongParam" : "Erro de parâmetro",
    "limitedTimeActivityOverTips" : "O evento expirou. Atualize a página.",
    "preRightsIntro" : "Devido a uma atualização de recurso, o evento \"Pontos VIP\" será descontinuado em breve.nHorário de término: \${offLineDate}nNão se esqueça de usar os cupons obtidos no evento \"Pontos VIP\" antes que eles expirem.nApós o término do evento, você pode visitar o Centro de Membros Premium para aproveitar mais benefícios:nComplete missões para ganhar pontos, que podem ser trocados por cupons, itens no jogo e outras recompensas! Aproveite benefícios exclusivos para membros e sorteios.nFique ligado para mais recompensas e eventos!",
    "riskTipTitle" : "Atenção para Comportamentos Ilegais e Golpes",
    "riskTipContent" : "Caro Jogador,\n\nNotamos que alguns jogadores estão se engajando em ações que perturbam a ordem e a justiça do jogo. As violações mais comuns incluem:\n\n1. Publicação de Anúncios Não Autorizados: Compartilhando anúncios não autorizados através do bate-papo do jogo ou outros canais, como promover comércio ilegal de recursos ou recargas não autorizadas.\n2. Uso de Trapaças ou Scripts: Usando trapaças, scripts ou outros meios técnicos para obter recursos de forma ilegal.\n3. Convites Não Autorizados: Enviando convites durante o bate-papo para atrair jogadores ao contato por canais externos (ex.: Line, Discord).\n4. Recargas Ilegais: Promovendo recargas não oficiais com preços descontados para atrair jogadores.\n5. Outros Golpes: Envolvimento em atividades fraudulentas, como se passar por funcionários oficiais.\n\nInstamos todos os jogadores a protegerem suas informações pessoais e ativos. Não confiem em mensagens relacionadas a comportamentos ilegais ou golpes. Essas violações acarretam riscos significativos, incluindo roubo de contas ou envolvimento em atividades fraudulentas. Por favor, observe que não forneceremos compensação por perdas resultantes dessas ações.\n\nPara contas encontradas envolvidas em tais comportamentos, tomaremos as medidas apropriadas com base na gravidade e no impacto das violações. As medidas podem incluir, mas não se limitam a, advertências, confisco de ganhos ilegais, suspensões temporárias ou banimentos permanentes. Se você encontrar algum comportamento suspeito no jogo, reporte à nossa equipe de suporte ao cliente. Investigaremos o mais rápido possível e tomaremos as medidas necessárias. Agradecemos pela sua compreensão e apoio.",
    "linkValid": "O link expirou",
    "-" : "-",
    "accountLabel": "Conta",
    "passwordLabel": "Senha",
    "confirmPasswordLabel": "Confirme sua senha",
    "confirmDeleteTitle" : "Tem certeza de que deseja excluir sua conta e todos os personagens?",
    "confirmDeleteYes" : "Sim. Quero excluir minha conta e todos os personagens.",
    "selectGame" : "Selecionar jogo",
    "confirmDeleteNo" : "Não. Quero excluir apenas um personagem. Gostaria de manter minha conta.",
    "delTermsTitle" : "Leia atentamente os requisitos e avisos de exclusão de conta.",
    "delCondTitle" : "1. Requisitos para exclusão de conta",
    "delCond1" : "(1) Entre na sua conta antes de se inscrever. Se não conseguir entrar, [recupere sua conta] primeiro. Certifique-se de que a conta do jogo e o personagem pertencem a você.",
    "delCond2" : "(2) Confirme que sua conta e personagem não têm <span>nenhum risco de segurança</span>, incluindo reclamações, relatórios, investigações, arbitragens ou processos judiciais não resolvidos (abertos por ou contra você).",
    "delCond3" : "(3) Confirme que sua conta e personagem não têm <span>nenhum pagamento pendente</span>, incluindo reembolsos não resolvidos ou assinaturas ativas.",
    "delNoticeTitle" : "2. Aviso de Exclusão de Conta",
    "delNotice1" : "(1) A exclusão desta conta de jogo e seus personagens associados será <span>permanente e irreversível</span>.",
    "delNotice2" : "(2) Por favor, <span>liquide quaisquer ativos pendentes no jogo</span>, incluindo, mas não se limitando a itens, moeda e assinaturas, antes de prosseguir, pois eles serão excluídos permanentemente após a exclusão da conta. Nenhum reembolso será emitido após o fechamento do servidor do jogo para contas ou personagens excluídos.",
    "delNotice3" : "(3) A exclusão de dados de conta e personagem também removerá ou tornará anônimas todas as informações relacionadas. No entanto, você terá que desvincular e gerenciar manualmente os dados associados a logins de mídia social de terceiros (por exemplo, Facebook).",
    "delNotice4" : "(4) Um período de espera de 14 dias (Período de reflexão) é fornecido para proteger seus interesses (exceto quando os regulamentos locais forem diferentes), durante o qual você pode entrar em contato com o suporte ao cliente para cancelar a solicitação de exclusão.",
    "delNotice5" : "(5) Após o envio bem-sucedido, sua conta será imediatamente congelada, mas a exclusão de dados pode levar até semana. Você receberá uma notificação por e-mail após a conclusão.",
    "delFormConfirm1" : "Eu entendo as condições e consequências da exclusão da conta.",
    "delFormConfirm2" : "Esta conta não tem relatórios ou litígios pendentes.",
    "delForm" : "Eu li e concordo com o <a class=\"account-delete-link\" href=\"javascript:;\">Contrato de Encerramento de Conta</a>.",
    "cannotDeleteMsgTitle" : "Não é possível excluir a conta",
    "cannotDeleteMsg1" : "Sua conta não atende aos requisitos para exclusão:",
    "cannotDeleteMsg2" : "Você tem tickets de suporte não resolvidos. Resolva-os antes de se inscrever novamente.",
    "cannotDeleteMsg3" : "Você tem reembolsos pendentes. Resolva-os antes de se inscrever para exclusão da conta.",
    "cannotDeleteMsg4" : "Sua conta está atualmente sob revisão devido a relatórios ou reclamações de jogadores. Aguarde a conclusão da revisão antes de se inscrever novamente.",
    "formCompleted" : "Ticket enviado",
    "formCheckMsg1" : "Seu ticket foi enviado, aguarde a revisão e a resposta.",
    "formCheckMsg2" : "Você pode verificar o andamento do ticket em <span class=\"account-delete-link\">[Meus Tickets]</span>.",
    "delEmailMsg1" : "Notificar você por e-mail após a exclusão?",
    "delEmailMsg2" : "A exclusão da conta levará cerca de uma semana devido ao processamento de dados. Você gostaria de receber uma notificação por e-mail após a conclusão?",
    "delEmailMsg3" : "Seu endereço de e-mail será usado apenas para fins de notificação.",
    "delEmailConfirmYes" : "Sim, por favor, notifique-me por e-mail.",
    "delEmailFill" : "Por favor, insira seu endereço de e-mail de notificação.",
    "delEmailConfirmNo" : "Não, não preciso de notificação por e-mail.",
    "delCoolMsg1" : "Você gostaria de um período de reflexão de 14 dias?",
    "delCoolMsg2" : "Durante o período de reflexão de 14 dias, sua conta será congelada, mas você pode enviar uma solicitação para cancelar a exclusão a qualquer momento. Após 14 dias, se você não tiver cancelado, sua conta será excluída e não poderá ser recuperada.",
    "delCoolMsg3" : "Se você optar por não ter um período de reflexão, sua conta será excluída imediatamente após a conclusão do aplicativo e não poderá ser recuperada.",
    "delCoolConfirmYes" : "Sim, eu quero um período de reflexão de 14 dias.",
    "delCoolConfirmNo" : "Não, exclua agora.",
    "delSecondCheckMsg1" : "Tem certeza de que lidou com todo o conteúdo da conta e deseja ativar o período de reflexão da conta? Sua conta ficará inacessível após a ativação.",
    "delSecondCheckConfirmYes" : "Sim, ative agora.",
    "delResMsg1" : "Sua solicitação de exclusão de conta foi enviada, e a seguinte conta foi congelada:",
    "gameName" : "Nome do jogo:",
    "gameAccount" : "Conta do jogo:",
    "delResMsg2" : "<span>Faça uma captura de tela e salve as informações da conta acima, pois é a única verificação se você precisar restaurar sua conta durante o período de reflexão</span>.",
    "delResMsg3" : "Período de reflexão: 14 dias. Tempo restante:",
    "delResMsg4" : "Para cancelar a solicitação de exclusão durante o período de reflexão, clique em [Entre em contato com o suporte].",
    "copyAccountInfo" : "Copiar informações da conta",
    "delResMsg5" : "Sua solicitação de exclusão de conta foi processada, e sua conta está sendo excluída no momento. Portanto, você não pode mais fazer login nela.",
    "delResMsg6" : "Devido à grande quantidade de dados envolvidos na exclusão de uma conta, levará algum tempo. Portanto, todos os rastros de sua conta não serão apagados imediatamente. Esperamos concluir esse processo em cerca de uma semana.",
    "delResMsg7" : "Se você forneceu anteriormente um endereço de e-mail de notificação, enviaremos um e-mail para esse endereço.",
    "delResMsg8" : "Se desejar fazer login no jogo novamente, você pode registrar uma nova conta.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Outros Canais",
    "itemWrong" : "Houve um erro na sua entrada. Por favor, tente novamente.",
    "delRegisterTime" : "Data de Registro",
    "delDevice" : "Dispositivo Frequentemente Usado",
    "delIp" : "Endereço de IP Frequentemente Usado",
    "delHistoryPayChannel" : "Canais de Recarga Históricos",
    "delHistoryPayOrder" : "Números de Pedidos Anteriores",
    "delDeleteReason" : "Motivo para Exclusão da Conta",
    "delPrevStep" : "Anterior",
    "delNextStep" : "Siguiente",
    "delSecondCheckMsg2" : "Você tem certeza de que cuidou de todo o conteúdo da conta e agora está procedendo com a exclusão da conta? Após a execução, sua conta não será mais acessível.",
    "pleaseFillIn" : "Por favor, forneça as seguintes informações",
    "switchNewVersion": "Mudar para nova",
    "switchNewVersionPlatform": "Plataforma de Pagamento",
    "updateVersionPopupContent": "Para garantir um desempenho de jogo fluido e suporte para novas funcionalidades, recomendamos que atualize o sistema do seu dispositivo para desfrutar de uma experiência de funcionamento mais estável e otimização de compatibilidade.",
    selectTopupTips: "90% dos usuários escolhem o centro de recarga oficial",
    chuzhi: "Carregar Valor",
    selectMethods: "Método de pagamento",
    landscapeTip2: "Por favor, gire o seu telemóvel para o modo retrato para uma melhor experiência",
    v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
    ckoNotAvailable: 'Erro no serviço de pagamento, tente novamente mais tarde.',
    ckoSubmitFail: 'Falha no pagamento. Verifique suas informações ou use outro cartão. Se o valor foi debitado, será reembolsado no método de pagamento original.',
    gotoFinish: 'A fazer',
    inAppPurchase: 'Compra no aplicativo',
}